export default {
	Active: "Ativo",
	Inactive: "Inativo",
	RequiredField: "Campo obrigatório",
	Close: "Fechar",
	Copy: "Copiar",
	Copied: "Copiado",
	CopiedToClipboard: "Copiado para a área de transferência",
	CopiedError: "Erro ao copiar",
	Duplicate: "Duplicado",
	With: "com",
	Date: "Data",
	Hour: "Hora",
	And: " e ",
	All: "Todos",
	Recent: "Recente",
	Check: "Verifica",
	ServiRoutes: "ServiRoutes",
	Clear: "Limpar",
	Filters: "Filtros",
	Go: "Ir",
	Ago: "Atrás",
	To: "Para",
	Next: "Seguinte",
	Previous: "Anterior",
	Information: "Informação",
	Options: "Opções",
	Selection: "Seleção",
	Serviform: "Serviforms",
	Serviroute: "Serviroute",
	ServiApps: "Servi Apps",
	Username: "Nome do usuário",
	Lastname: "Último nome",
	Email: "Email",
	Role: "Cargo",
	Status: "Estado",
	Type: "Tipo",
	New: "Novo",
	Help: "Ajuda",
	Replace: "Substituir",
	Name: "Nome",
	Days: "Dias",
	Locate: "Localizar",
	ErrorTitle: "Um erro ocorreu",
	ErrorMessage: "Um erro ocorreu. Por favor, tente novamente!",
	Enter: "Insira",
	ContactPerson: "Pessoa de contato",
	Country: "País",
	City: "Cidade",
	Department: "Departamento / Província / Estado / Região",
	Province: "Província",
	Region: "Região",
	State: "Estado",
	Canton: "Cantão",
	Municipality: "Município",
	District: "Distrito",
	Commune: "Comuna",
	Description: "Descrição",
	InitDate: "Data de Inicialização",
	EndDate: "Data final",
	InitHour: "Hora inicial",
	EndHour: "Hora de Fim",
	Address: "Endereço",
	Identification: "Identificação",
	Phone: "Telefone",
	Submit: "Enviar",
	Accept: "aceitar",
	Cancel: "cancelar",
	Reset: "reiniciar",
	Action: "Açao",
	Actions: "Ações",
	AddNew: "Adicionar novo",
	AddNew2: "Adicionar novo",
	Start: "Comece",
	End: "Feche",
	Startandend: "Comece e feche",
	Update: "atualizar",
	Dashboard: "Painel",
	eCommerce: "comércio eletrônico",
	Apps: "Apps",
	Todo: "tudo",
	Calendar: "Calendário",
	FullCalendar: "Calendário Completo",
	SimpleCalendar: "Calendário Simples",
	Shop: "fazer compras",
	ItemDetails: "Detalhes do item",
	Cart: "Carrinho",
	WishList: "Lista de Desejos",
	Checkout: "Confira",
	UI: "UI",
	DataList: "Lista de Dados",
	ListView: "Exibição de lista",
	ThumbView: "Visualização do polegar",
	Grid: "Rede",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Cores",
	Card: "Cartão",
	Basic: "Básico",
	Analytics: "Analytics",
	CardActions: "Ações do cartão",
	CardColors: "Cores do cartão",
	Table: "Tabela",
	agGridTable: "ag Tabela de grade",
	Components: "Componentes",
	Alert: "Alerta",
	Avatar: "Avatar",
	Badge: "Distintivo",
	Breadcrumb: "Migalhas de pão",
	Button: "Botão",
	ButtonGroup: "Grupo de Botão",
	Chip: "Lasca",
	Collapse: "Colapso",
	Dialogs: "Diálogos",
	Divider: "Divisor",
	DropDown: "Suspenso",
	List: "Lista",
	Loading: "Carregando",
	Navbar: "Barra de navegação",
	Notifications: "Notificações",
	Pagination: "Paginação",
	Popup: "Aparecer",
	Progress: "Progresso",
	Sidebar: "Barra Lateral",
	Slider: "controle deslizante",
	Tabs: "guias",
	Tooltip: "Dica de ferramenta",
	Upload: "Envio",
	Manage: "Gerenciar",
	FormsAndTable: "Formulários e mesa",
	FormElements: "Elementos do Formulário",
	Select: "Selecione",
	SelectAll: "Selecionar tudo",
	Deselect: "Desmarcar todos",
	Switch: "Trocar",
	Checkbox: "Caixa de seleção",
	Required: "Obrigatória",
	Radio: "Rádio",
	Input: "Entrada",
	NumberInput: "Número de entrada",
	Textarea: "Textarea",
	FormLayouts: "Form Layouts",
	FormWizard: "Assistente de Formulários",
	FormValidation: "Validação de Formulário",
	FormInputGroup: "Grupo de entrada do formulário",
	Pages: "Páginas",
	Authentication: "Autenticação",
	Register: "Registro",
	ForgotPassword: "Esqueceu sua senha",
	LockScreen: "Tela de bloqueio",
	Miscellaneous: "Diversos",
	ComingSoon: "Em breve",
	Error: "Erro",
	404: "404",
	500: "500",
	NotAuthorized: "Não autorizado",
	Maintenance: "Manutenção",
	Profile: "Perfil",
	Logout: "Sair",
	User: "do utilizador",
	View: "Visualizar",
	UserSettings: "Configurações do Usuário",
	CompanySettings: "Configurações da empresa",
	Invoice: "Fatura",
	FAQ: "Perguntas frequentes",
	Search: "Procurar",
	SearchBy: "Procurar por",
	SearchOn: "Pesquisa em",
	CurrentPage: "Pagina atual",
	AllPages: "Todas as páginas",
	KnowledgeBase: "Base de Conhecimento",
	ChartsAndMaps: "Gráficos e mapas",
	Charts: "Gráficos",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensões",
	QuillEditor: "Quill Editor",
	DragAndDrop: "Arraste e solte",
	Datepicker: "Datepicker",
	DatetimePicker: "Datetime Picker",
	AccessControl: "Controle de acesso",
	I18n: "I18n",
	Carousel: "Carrossel",
	Clipboard: "Prancheta",
	ContextMenu: "Menu contextual",
	StarRatings: "Avaliações de estrelas",
	Autocomplete: "Autocompletar",
	Tree: "Árvore",
	Import: "Importar",
	Export: "Exportar",
	Selected: "Selecionado",
	ExportSelected: "Exportar selecionados",
	ExportAll: "Exportar Tudo",
	CellAutoWidth: "Largura Automática da Célula",
	EnterFileName: "Digite o nome do arquivo",
	Others: "Outros",
	MenuLevels: "Níveis de Menu",
	MenuLevel2p1: "Níveis de Menu 2.1",
	MenuLevel2p2: "Níveis de Menu 2.2",
	MenuLevel3p1: "Níveis de Menu 3.1",
	MenuLevel3p2: "Níveis de Menu 3.2",
	DisabledMenu: "menu desativado",
	Support: "suporte",
	Documentation: "Documentação",
	RaiseSupport: "Levante o Suporte",
	demoTitle: "Título do Cartão",
	demoText:
		"Bolo de gergelim estala cupcake pão de gengibre dinamarquês Eu amo pão de gengibre. Torta de maçã jujubas chupa chups muffin halvah pirulito. Bolo de chocolate Bolo de aveia tiramisu maçapão açúcar ameixa. Donut torta doce de aveia bolo de frutas bolo de frutas algodão doce gotas de limão",
	ExportToExcel: "Exportação para Excel",
	Map: "Mapa",
	Programed: "PROGRAMEDO",
	Executed: "EXECUTADO",
	Both: "ambos",
	Company: "Empresa",
	NewCompany: "Nova Empresa",
	UpdateCompany: "Atualizar empresa",
	ListOfCompanies: "Lista de empresas",
	TitleConfirmCompanyCreate: "Empresa criada",
	TextConfirmCompanyCreate: "A empresa foi criada com sucesso",
	TitleConfirmCompanyDelete: "Empresa excluída",
	TextConfirmCompanyDelete: "A empresa selecionada foi excluída com sucesso",
	TitleConfirmCompanyUpdate: "Empresa atualizada",
	TextConfirmCompanyUpdate: "A empresa selecionada foi atualizada com sucesso",
	DeleteCompany: "Tem certeza de que deseja excluir esta empresa? Por favor aceite para continuar",
	Confirm: "Confirme",
	MissingFieldTitle: "Campos ausentes",
	MissingField: "Alguns campos estão faltando no formulário",
	CompanyName: "Nome da empresa",
	CompanyFormTitleCreate: "Formulário para criar uma nova empresa",
	CompanyFormTitleUpdate: "Formulário para atualizar uma empresa",
	CompanyConfigCrud: "Configuração da Empresa",
	CompanyAddNewField: "Adicionar campo adicional",
	CompanyConfigCrudFormTitleCreate: "Formulário para criar uma configuração de empresa",
	CompanyConfigCrudFormTitleEdit: "Formulário para editar a configuração de uma empresa",
	CompanyConfigCrudFormTitle: "Formulário para criar uma configuração de empresa",
	CompanyConfNameAddLabel: "Nome do Campo",
	CompanyConfValueAddLabel: "Valor",
	CompanyConfNameAddValidMessage: "Apenas caracteres alfabéticos, sem espaços",
	CompanyConfValueAddValidMessage: "Por favor insira o valor aqui",
	DeleteCompanyConf: "Tem certeza de que deseja excluir esta empresa de configuração?",
	TitleConfirmCompanyConfigDelete: "Empresa de configuração excluída",
	TextConfirmCompanyConfigDelete: "A configuração selecionada foi excluída com sucesso",
	TitleConfirmCompanyConfigCreate: "Empresa de configuração criada",
	TextConfirmCompanyConfigCreate: "A configuração foi criada com sucesso",
	TitleConfirmCompanyConfigUpdate: "Empresa de configuração atualizada",
	TextConfirmCompanyConfigUpdate: "A configuração selecionada foi atualizada com sucesso",
	NewCompanyConfig: "Nova Config Company",
	UpdateCompanyConfig: "Atualizar empresa de configuração",
	ListOfCompaniesConfig: "Lista de empresas de configuração",
	TitleWarningExistPropertyCompanyConfig: "Já existe",
	TextWarningExistPropertyCompanyConfig: "O valor a ser inserido já é",
	UpdateCompanyConfigErrorMessage: "Ocorreu um erro ao atualizar as configurações da empresa",
	IvalidValuesErrorMessage: "valores inválidos",
	TypeConfig: "Tipo de Configuração",
	NewTypeConfig: "Novo tipo de configuração",
	NewTypeConfigRequired: "Tipo de configuração necessária",
	UpdateTypeConfig: "Atualizar tipo de configuração",
	ListOfTypeConfig: "Lista de tipos de configuração",
	InputNameTypeConfig: "Digite o nome",
	ButtonAddTypeConfig: "Adicionar",
	TitleConfirmTypeConfigUpdate: "Configuração de tipo modificada",
	TextConfirmTypeConfigUpdate: "O tipo de configuração selecionado foi modificado com sucesso",
	TypeConfigCrudFormTitleCreate: "Formulário para criar um tipo de configuração",
	TypeConfigCrudFormTitleEdit: "Formulário para editar um tipo de configuração",
	TitleSuccessTypeConfigCreated: "Configuração de tipo criada",
	TextSuccessTypeConfigCreated: "O tipo de configuração foi criado com sucesso",
	TitleSuccessTypeConfigCreatedError: "Erro ao criar tipo de configuração",
	TextSuccessTypeConfigCreatedError: "O tipo de configuração não foi criado",
	DeleteTypeConf: "Tem certeza de que deseja excluir este tipo de configuração?",
	TypeConfigConfigName: "Digite o nome da configuração",
	TypeConfigStatus: "Status",
	TypeConfigAddDateOn: "Adicionado",
	Tipology: "Tipologia",
	TextConfirmTipologyCreate: "Tipologia foi criada com sucesso",
	TextConfirmTipologyUpdate: "Tipologia foi atualizada com sucesso",
	TextConfirmTipologyDelete: "Tipologia foi excluída com sucesso",
	TitleConfirmTipologyCreate: "Tipologia criada",
	TitleConfirmTipologyUpdate: "Tipologia atualizada",
	TitleConfirmTipologyDelete: "Tipologia excluída",
	TextDeleteTipology: "tem certeza de deletar a tipologia",
	TextAccepContinue: "Por favor aceite para continuar",
	Save: "Salve",
	Edit: "Editar",
	Remove: "retirar",
	Add: "Adicionar",
	Category: "Categoria",
	NewCategory: "Nova categoria",
	ListOfCategories: "Lista de categorias",
	TitleConfirmCategoryCreate: "Objeto criado",
	TitleConfirmCategoryUpdate: "Objeto atualizado",
	TitleConfirmCategoryDelete: "Objeto excluído",
	TextConfirmCategoryCreate: "O novo objeto foi criado com sucesso!",
	TextConfirmCategoryUpdate: "O objeto foi atualizado com sucesso!",
	TextConfirmCategoryDelete: "O objeto foi excluído com sucesso!",
	Resources: "Recursos",
	CreateResource: "Criar recurso",
	CreateObject: "Criar Objeto",
	ResourceList: "Lista de Recursos",
	ResourceView: "Visualização de recursos",
	Objects: "Objetos",
	ObjectType: "Tipo de objeto",
	NewObject: "Novo objeto",
	ListOfObjects: "Lista de objetos",
	TooltipSchemas: "O esquema define as propriedades mínimas que podem ter objetos dependendo do tipo selecionado.",
	Config: "Configuração",
	VisitPoint: "Ponto de visita",
	VisitPoints: "Pontos de visita",
	CreateVisitPoint: "Criar Ponto de Visita",
	UpdateVisitPoint: "Atualizar Ponto de Visita",
	ListVisitPoint: "Lista de pontos de visita",
	MassiveDelete: "Exclusão massiva",
	ActivityList: "Lista de Atividades",
	TitleConfirmActivityCreate: "Atividade criada",
	TextConfirmActivityCreate: "A atividade foi criada com sucesso",
	TitleConfirmActivityDelete: "Atividade excluída",
	TextConfirmActivityDelete: "A atividade selecionada foi excluída com sucesso",
	TitleConfirmActivityUpdate: "Atividade atualizada",
	TextConfirmActivityUpdate: "A atividade selecionada foi atualizada com sucesso",
	DeleteActivity:
		"Ao excluir uma atividade, lembre-se de que todas as visualizações associadas também serão excluídas e serão gerenciadas com esta atividade. A atividade selecionada é",
	DeleteActivityConfirm: "Digite o nome da atividade na caixa de texto a seguir para continuar a exclusão",
	UpdateActivity: "Atividade de atualização",
	CreateActivity: "Criar atividade",
	Hours: "Horas",
	Minutes: "Minutos",
	TitleConfirmEventCreate: "Cronograma criado",
	TextConfirmEventCreate: "A programação foi criada com sucesso",
	TitleConfirmEventDelete: "Cronograma excluído",
	TextConfirmEventDelete: "A programação selecionada foi excluída com sucesso",
	TitleConfirmEventUpdate: "Cronograma atualizado",
	TextConfirmEventUpdate: "A programação selecionada foi atualizada com sucesso",
	DeleteEvent: "Tem certeza de que deseja excluir esta programação? Por favor aceite para continuar",
	PopupScheduleTitleCreate: "Criar nova programação",
	CreateSeveralSchedule: "Crie toda a programação",
	PopupScheduleTitleUpdate: "Cronograma de atualização",
	ListGroup: "Lista de Grupo",
	UpdateGroup: "Grupo de atualização",
	CreateGroup: "Criar grupo",
	TitleConfirmGroupCreate: "Grupo Criado",
	TextConfirmGroupCreate: "O grupo foi criado com sucesso",
	TitleConfirmGroupDelete: "Grupo Excluído",
	TextConfirmGroupDelete: "O grupo selecionado foi excluído com sucesso",
	TitleConfirmGroupUpdate: "Grupo Atualizado",
	TextConfirmGroupUpdate: "O grupo selecionado foi atualizado com sucesso",
	ID: "ID",
	Alls: "tudos",
	RemoveFigure: "Remover Figura",
	NoTracking: "sem rastreamento",
	NotDataExecuteDescription: "Nenhum dado encontrado para pintar a rota executada",
	NotScheduleDescription: "Nenhum compromisso agendado encontrado para pintar a rota",
	NoDating: "Sem namoro",
	VisualizeVisitPoint: "Ver Ponto de Visita",
	NoDataAvailable: "Sem dados disponíveis",
	ValidateField: "O campo {n} é obrigatório",
	Statistics2: {
		Statistics: "Estatisticas",
		VisitsStatistics: "Estatísticas de visitas para o mês exibidas no calendário",
	},
	Crud: {
		Create: "Criar",
		Read: "Leitura",
		Update: "Atualizar",
		Delete: "Deleta",
		List: "Lista",
		Additionals: "Adicionais",
		Modules: "Módulos",
		Cancel: "Cancelar",
		Finalize: "Finalizar",
		Edit: "Editar",
		Add: "Adicionar",
		Remove: "Remover",
	},
	Languages: {
		Languages: "Línguas",
		Language: "Língua",
		Spanish: "Espanhol",
		English: "Inglês",
		Portuguese: "Português",
		French: "Francês",
		German: "Alemão",
		Spa: "Esp",
		Eng: "Ing",
		Por: "Por",
		Fre: "Fra",
		Ger: "Ale",
	},
	ExportTo: {
		Points: "Pontos de exportação de visita",
		Resources: "Recursos de exportação",
	},
	MapModule: {
		Latitude: "Latitude",
		Longitude: "Longitude",
		MapAppearance: "Aspecto do mapa",
		Coordinates: "Coordenadas",
		CopyCoords: "Copiar Coordenadas",
		GeoAgain: "Georreferenciamento Novamente",
		ActivateTraffic: "Ativar trânsito",
		DisableTraffic: "Desativar trânsito",
		Traffic: "Camada de tráfego",
		Default: "Predefinição",
		Satellite: "Satélite",
		Hybrid: "Híbrido",
		Terrain: "Terreno",
		MapOptions: "Opções de mapa",
		Route: "Rota",
		Routes: "Rotas",
		SearchRoutes: "Rotas de Pesquisa",
		RouteType: "Tipo de Rota",
		RealTimeTracking: "Rastreamento em tempo real",
		NoLocate: "Não foi possível localizar este recurso, coordenadas não detectadas.",
		OnLine: "conectados",
		OffLine: "Desligado",
		LastTransmission: "Última Transmissão",
		StrokeOpacity: "Opacidade de traço",
		StrokeWeight: "Peso do curso",
		StrokeColor: "Cor do traço",
		OptimizeWaypoints: "Optimizar pontos de ruta",
		ShowWaypoints: "Mostrar pontos de ruta",
		ShowWaypointsText: "Mostrar marcadores das posições informadas pelo dispositivo móvel.",
		ShowWaypointsTextConfirm1: "Habilitar estas opções ",
		ShowWaypointsTextConfirm2: " pode causar lentitud en la renderizacion y fluidez del mapa.",
		ShowLinearRoute: "Mostrar rota linear",
		ShowLinearRouteText:
			"Mostrar uma rota executada com o rastreamento real das posições informadas pelo dispositivo móvel sem levar em consideração a geometria da estrada.",
		ShowLabel: "Mostrar Números",
		ShowLabelText: "Mostrar etiqueta com o número consecutivo de cada marcador.",
		ScheduledRoute: "Rota Agendada",
		ScheduledRouteZeroResult: "Não foi possível rastrear uma rota para visitas programadas.",
		ExecutedRoute: "Rota Executada",
		ExecutedRouteLinear: "Rota Executada Linearmente",
		ConfigText: "Personalize algumas das propriedades visíveis para as rotas",
		CardsView: "Visualização de cartas",
		ChangeCardsView: "Altere a visualização de recursos para cartões",
		ChangeListView: "Mude a visão do recurso para listar",
		Georeferencer: "Georreferenciador",
		GeoSub: "Georreferenciar e localizar o endereço inserido no mapa.",
		Views: "Visualizações",
		ListView: "Exibição de lista",
		CardView: "Visualização de cartão",
		ChangeCardView: "Alterar vista para cartões.",
		Minimize: "Minimizar",
		Maximize: "Maximizar",
		SeeDayScheduledRoute: "Veja no mapa a rota programada do dia.",
		SeeDayExecutedRoute: "Veja no mapa a rota executada do dia.",
		QuotesDay: "Citações do dia",
		SeeListQuotesDay: "Veja a lista de compromissos do dia",
		GenerateRoute: {
			Title: "Erro ao gerar rota.",
			Text: "Nenhum dado foi encontrado para a rota executada.",
		},
		ErrorGenerateAppointment: {
			Title: "Erro ao criar compromisso",
			Text: "Erro ao consultar dados",
		},
		CurrentPosition: "Posição atual",
		CellAutoWith: "Largura Automática da Célula",
		AlertVisualizarInfo: "Para ver a lista de recursos, selecione um grupo da lista no topo.",
		ResourcesNotFound: "Não há recursos relacionados encontrados com o grupo selecionado.",
		SitidataNoEnabled: "SITIDATA API não habilitada para esta empresa.",
		TrackingInformation: "Informações de Rastreamento",
		Line: "linha",
		Points: "Pontos",
		Numbers: "Números",
		AlertRouteLinear: "Esta opção não está habilitada para rotas com vários recursos",
		Georeference: "georeferenciação",
		GeoreferencingByAddress:
			"Foi ativado o georreferenciamento por endereço para encontrar as coordenadas e localizá-las no mapa, você deve fazer",
		DiscardTheChanges: "Ou para descartar as alterações clique",
		GeoCoordinates: "Georreferenciar e localizar as coordenadas no mapa pelo endereço inserido",
		mobile_app_version: "Versão do aplicativo móvel",
		android_os_version: "Versão do sistema operacional Android",
		software_details: "Detalhes do software",
		no_transmission: "sem transmissão",
	},
	Roles: {
		Roles: "Funções",
		SelectRole: "Selecione uma função",
		FormTitleRoleCreate: "Formulário para criar uma função",
		FormTitleRoleEdit: "Formulário para editar uma função",
		CreateLabel: "Criar papel",
		UpdateLabel: "Editar papel",
		ListLabel: "Lista de funções",
		FormInputRoleName: "Nome do papel",
		FormInputRoleAlias: "Alias do nome da função",
		FormInputRoleDescription: "Descrição da Função",
		FormInputPermit: "Permissões",
		ValidMessages: {
			ValidRoleName: "Insira um valor, sem caracteres especiais",
			ValidRoleDescription: "Insira um valor",
			ValidRolePermissions: "Selecione as permissões",
		},
		Permissions: {
			TitleConsultPermissionsError: "Erro",
			TextConsultPermissionsError: "Erro ao consultar permissões",
			NotPermissions: "Você não tem permissão para esta opção!",
			NotPermissionsTitle: "Sem permissão",
			NotPermissionsText: "Contate o administrador da plataforma para obter permissão.",
			RequiredPermissionsText: "Você precisa de permissões para",
			JsonConfigNotFoundTex:
				"Você precisa criar uma configuração para esta opção. Vá para o módulo de configuração da empresa.",
			RequiredConfig: "Configuração Necessária",
			RequiredConfigText:
				"é uma configuração necessária para este processo, entre em contato com o administrador da plataforma",
		},
		GetRoles: {
			TitleError: "Erro",
			TextError: "Erro ao consultar funções",
		},
		Create: {
			Title: "Função criada",
			Text: "Função criada com sucesso",
			TitleError: "Erro",
			TextError: "A função não foi criada",
		},
		Update: {
			Title: "Função modificada",
			TextRoleCreated: "Função modificada com sucesso",
			TitleRoleCreatedError: "Erro",
			TextRoleCreatedError: "A função não foi modificada",
			Text: "Função modificada com sucesso",
			TitleError: "Erro",
			TextError: "A função não foi modificada",
		},
		ListView: {
			columnsNames: {
				Name: "Função de nome",
				AddedOn: "Adicionado",
				Description: "Descrição",
			},
			DeleteRole: {
				TextToConfirm: "Tem certeza de que deseja eliminar a função selecionada?",
				TitleSuccess: "Papel eliminado",
				TextSuccess: "A função selecionada foi removida",
				TitleError: "Erro ao eliminar a função",
				TextError: "A função selecionada não foi removida",
			},
		},
	},
	Permissions: {
		Permissions: "Permissões",
		RequiredPermissions: "Permissões necessárias",
		FormTitlePermissionCreate: "Formulário para criar uma permissão",
		FormTitlePermissionEdit: "Formulário para editar uma permissão",
		CreateLabel: "Permissão de criação",
		UpdateLabel: "Permissão de edição",
		ListLabel: "Lista de permissões",
		GetPermissions: {
			TitleError: "Erro",
			TextError: "Erro ao consultar as permissões",
		},
		GetRole_Permission: {
			TitleError: "Erro",
			TextError: "Erro ao consultar relacionamentos",
		},
		GetRoles: {
			TitleConsultPermissionsError: "Erro",
			TextConsultPermissionsError: "Erro ao consultar as funções",
		},
		FormInputPermissionName: "Permissão de nome",
		FormInputPermissionDescription: "Descrição",
		FormInputRoles: "Funções",
		ValidMessages: {
			ValidPermissionName: "Insira um valor, sem caracteres especiais",
			ValidPermissionDescription: "Insira um valor",
		},
		Create: {
			Title: "Permissão criada",
			Text: "Permissão criada com sucesso",
			TitleError: "Erro",
			TextError: "A licença não foi criada",
		},
		Update: {
			Title: "Permissão modificada",
			Text: "Permissão modificada com sucesso",
			TitleError: "Erro",
			TextError: "A permissão não foi modificada",
		},
		ListView: {
			columnsNames: {
				Name: "Permissão de nome",
				AddedOn: "Adicionado",
				Description: "Descrição",
			},
			DeleteRole: {
				TextToConfirm: "Você tem certeza de eliminar a permissão selecionada?",
				TitleSuccess: "Permissão excluída",
				TextSuccess: "A permissão selecionada foi eliminada",
				TitleError: "Erro ao eliminar permissão",
				TextError: "A permissão selecionada não foi eliminada",
			},
		},
	},
	StatusModule: {
		StatusLink: "Estado",
		Create: "Criar estado",
		ColumnsName: {
			Name: "Nome do estado",
			Added: "Adicionado",
		},
		GetStatus: {
			TitleError: "Erro",
			TextError: "Erro ao consultar o estado",
		},
		ValidMessages: {
			ValidName: "Insira um valor, sem caracteres especiais",
		},
		PopupCreate: {
			LabelTittle: "Criar estado",
			LabelButton: "Crio",
		},
		ResponseCreate: {
			Title: "Estado criado",
			Text: "O Estado foi criado corretamente",
			TitleError: "Erro",
			TextError: "O Estado não foi criado corretamente",
		},
		PopupEdit: {
			LabelTittle: "Editar Estado",
			LabelInput: "Estado do nome",
			LabelButton: "Editar",
		},
		ResponseEdit: {
			Title: "Estado editado",
			Text: "O Estado foi editado corretamente",
			TitleError: "Erro",
			TextError: "O Estado não foi editado corretamente",
		},
		PopupDelete: {
			LabelText: "Você tem certeza de eliminar o Estado selecionado?",
		},
		ResponseDelete: {
			Title: "Estado excluído.",
			Text: "O Estado foi excluído corretamente",
			TitleError: "Erro",
			TextError: "O Estado não foi excluído corretamente",
		},
	},
	StatusMobile: {
		StatusMobile: "Estado para celulares",
		StatusMobileName: "Nome do Estado para celular",
		ListStatusMobile: {
			ListStatusMobile: "Lista de Estado para celular",
			Description: "Descrição",
			ActiveForm: "Formulário Ativo",
			ActiveEventToltip:
				"Esta opção indica se no estado atual é ou não possível iniciar eventos (visitas) Por exemplo, ativar para permitir que as visitas comecem na hora do almoço.",
			ActiveEvent: "Iniciar Evento",
			ZoneRequired: "Zona Necessária",
			ZoneRequiredToltip:
				"Esta opção restringe se na aplicação móvel (recurso) é possível ativar um estado dentro ou fora da área atribuída ao recurso.",
			Status: "Estado",
			Active: "Ativado",
			Disabled: "Desabilitado",
			Company: "Empresa",
			ErrorTitle: "O status não foi atualizado",
			ErrorStatus: "Os status não pode ser alterado até que o celular tenha transmitido pelo menos uma vez",
		},
		FormStatusMobile: {
			CreateStatusMobile: "Criar estado para celular",
			UpdateStatusMobile: "Atualizar estado para celular",
			FormTitleCreate: "Formulário para criar um status para celular",
			FormTitleUpdate: "Formulário para editar um status para celular",
			ValidMessages: {
				Name: "nsira um valor, sem caracteres especiais",
				Description: "Insira um valor",
			},
			Create: {
				Success: {
					Title: "Estado para celular",
					Text: "Criado com sucesso",
				},
				Error: {
					Title: "Estado para celular",
					Text: "Não foi criado com sucesso",
				},
			},
			Update: {
				Success: {
					Title: "Estado para celular",
					Text: "editado com sucesso",
				},
				Error: {
					Title: "Estado para celular",
					Text: "Não foi editado com sucesso",
				},
			},
			Delete: {
				Text: "Tem certeza de que deseja excluir o status dos celulares selecionados?",
				Success: {
					Title: "Estado para celular",
					Text: "Apagado com sucesso",
				},
				Error: {
					Title: "Estado para celular",
					Text: "Não foi removido com sucesso",
				},
			},
		},
	},
	NewTipology: {
		name: "Escreva o nome",
		description: "Escreva uma descrição aqui",
	},
	Resource: {
		Resource: "Recurso",
		Resources: "Recursos",
		DeleteResource: "Apagar Recurso",
		DeleteResources: "Deletar recursos",
		DeleteAllResources: "Deletar todos os recursos",
		AssigResources: "Atribuir Recursos",
		NotResources: "Nenhum recurso atribuído",
		AssignResourceToltip: "Carregue a lista de recursos disponíveis para continuar com a atribuição.",
		ShowAssigneResource: "Mostrar recursos atribuídos",
		ShowAssigneResourceToltip: "Mostra a lista dos recursos atribuídos.",
		EmailInvalid: "O endereço de e-mail não tem um formato válido.",
		UsernameInvalid: "O nome de usuário é muito curto, mínimo de 5 caracteres.",
		emailRequired: "O email é obrigatório",
		identificationRequired: "A identificação é necessária",
		lastnameRequired: "O sobrenome é obrigatório",
		nameRequired: "O nome é obrigatório",
		usernameRequired: "O nome de usuário é obrigatório",
		BackButton: "Voltar",
		FinishButton: "Terminar",
		Definition: "Definição",
		ObjectProperties: "Propriedades do objeto",
		Summary: "Resumo",
		ObjectCreated: "Objeto criado",
		Loading: "Carregando...",
		DeleteAllText: "Tem certeza de remover todos os recursos da tabela?",
		SearchMultipleId: "Pesquisar vários resultados inserindo IDs separados por vírgulas",
		TotalResources: "Recursos totais",
		NoticeNewObject: {
			Text1: "Você criará um novo objeto",
			Text2: "do tipo",
			Text3: "com as propriedades descritas abaixo, valide as informações e pressione",
			Text4: "para prosseguir com a criação.",
		},
		PrincipalProperties: "Propriedades principais",
		Continue: "Prosseguir",
		AdditionalProperties: "Propriedades Adicionais",
		FinalizeContent: {
			Message:
				"O novo objeto foi criado com sucesso e pronto para ser usado, selecione uma das seguintes opções para encerrar este processo",
			CreateResource: "Criar Recurso",
			CreateVisitPoint: "Crie um Ponto de Visita",
			ViewAllObject: "Ver todos os objetos",
		},
		NameInvalid: {
			Title: "Nome inválido",
			Text: "O nome do objeto não aceita acentos ou caracteres especiais",
			Text1: "O nome do objeto aceita apenas letras e números.",
		},
		SchemeInvalid: {
			Title: "Esquema inválido",
			Text: "Selecione um esquema para poder continuar com a criação do objeto",
		},
		CorrectAllValues: "corrija todos os valores",
		List: {
			CellRenderer: {
				DeleteRecord: "Você está prestes a deletar",
				DeleteSuccess: {
					Title: "Recurso eliminado",
					Text: "O recurso selecionado foi removido com sucesso",
				},
			},
		},
		Create: {
			TabLabel: "Criar Recurso",
			LoadResourcesType: "Carregando tipos de recursos!",
			ReosurceType: "Tipo de recurso",
			SelectType: "Selecione o tipo de objeto para renderizar o formulário.",
			Success: {
				Title: "Recurso criado",
				Text: "Um novo recurso foi criado no sistema.",
			},
		},
		Edit: {
			EditResource: "Editar Recurso",
			UserNotFound: {
				Text1: "Registro do usuário com id:",
				Text2: "não encontrado.",
				Check: "Verificar",
				AllUsers: "Todos os usuários",
			},
			ValidMessages: {
				Username: "O campo de nome de usuário é obrigatório, sem caracteres especiais ou espaços",
				Email: "O campo de e-mail é obrigatório, com o formato correto",
				Status: "O campo de status é obrigatório",
				Lastname: "O campo lastName é obrigatório",
				Identification: "O campo de identificação é obrigatório",
				Nombre: "O campo do nome é obrigatório, sem caracteres especiais ou números",
				Role: "O campo de função é obrigatório",
				Dynamic: {
					Text1: "o",
					Text2: "campo é obrigatório",
				},
				VisitPointInactive:
					"Não é possível atualizar o recurso porque possui pontos de visita inativos ou não encontrados atribuídos, verifique os pontos de visita com id:",
			},
		},
		View: {
			AssignedActivities: "Atividades atribuídas",
			NotAssignedActivities: "Não há atividades atribuídas",
			NotImeiCode:
				"Ele não tem um código imei registrado, é possível que o recurso nunca tenha feito o login a partir da aplicação móvel",
		},
	},
	ErrorVariable: {
		Textvariable1: "O campo está ausente ou incorreto!",
	},
	Object: {
		Object: "Objeto",
		CreateObject: "Criar Objeto",
		AdditionalFields: "Campos Adicionais",
		AdditionalField: "Campo Adicional",
		PrincipalFields: "Campos Principais",
		TypeField: "Campo Tipo",
		Label: "Rótulo",
		EnableEditing: "Habilitar edição",
		ChangeName: "Mude o nome",
		SaveChanges: "Salvar alterações",
		TypeName: "Digite o nome",
		EnterNewName: "Insira o novo nome",
		ChangeObjectName: "Alterar o nome do objeto",
		ObjectName: "Nome do objeto",
		TypeLabel: "Rótulo de tipo",
		Basics: "Básico",
		Required: "Obrigatório",
		Yes: "Sim",
		Not: "Não",
		LabelHelp: "Nome visível no formulário",
		Options: "Opções (Opções de valor: Preto)",
		OptionsLabel: "Adicionar opções escreva: (Valor da opção: Cor em inglês)",
		Property: "Propriedade",
		Properties: "Propriedades",
		PropertyDefinition: "Definição de propriedade",
		ValidMessages: {
			name: "O campo do nome é obrigatório, sem caracteres especiais ou espaços",
			label: "O campo do rótulo é obrigatório",
			status: "O campo de status é obrigatório",
			cat: "O campo da categoria é obrigatório",
		},
		DeleteObject: {
			Text1: "Tem certeza de que deseja eliminar o objeto",
			Text2: "Aceite para continuar.",
		},
		DeleteField: {
			Text1: "Tem certeza de que deseja eliminar o campo",
			Text2: "Aceite para continuar.",
		},
		NumProperties:
			"Selecione um esquema para ver as propriedades mínimas que o objeto pode ter ou também para poder adicionar novas propriedades deste.",
		SelectSchemeLabel: "SELECIONE O ESQUEMA",
		SelectSchemeValue: "SELECIONE_O_ESQUEMA",
		SelectedTipology: {
			label: "Recursos",
		},
		Field: {
			label: "Texto",
		},
		statusOptions: {
			Date: "Data",
			DateTime: "Data hora",
			Text: "Texto",
			Number: "Número",
			Email: "Email",
			Select: "Seleção",
			Url: "Url",
			File: "Arquivo",
			Image: "Imagem",
			Coordinates: "Coordenadas",
			DefaultLocation: "Localização padrão",
			Radio: "Várias opções",
			Checkbox: "Caixa de seleção",
			Dropdown: "Menu suspenso",
			Switch: "Boleano",
			Composed: "Composta",
			MultipleChoice: "Seleção múltipla",
		},
		nameOptions: {
			VISIT_POINT: "PONTO DE VISITA",
			RESOURCE: "RECURSO",
			SCHEDULE: "CRONOGRAMA",
			LAYER: "CAMADA",
		},
		ErrorFields: {
			Title: "Erro nos campos",
			Text: "Alguns campos estão faltando ou são inválidos!",
		},
		UserDeleted: {
			Title: "Usuário excluído",
			Text: "O usuário selecionado foi excluído com sucesso.",
		},
		UserInvalid: {
			Title: "Nome inválido",
			Text: "O nome do objeto aceita apenas letras e números.",
		},
	},
	VisitPointObject: {
		Create: {
			SelectObjectType: "Selecione o tipo de objeto",
			ValidMessages: {
				ObjectType: "O tipo de objeto é obrigatório",
				Name: "O campo nome é obrigatório",
				Identification: "O campo de identificação é obrigatório, sem caracteres especiais ou espaços",
				Phone: "O campo do telefone é obrigatório",
				Address: "O campo de endereço é obrigatório",
				Country: "O campo do país é obrigatório",
				Departament: "O campo do departamento é obrigatório",
				City: "O campo da cidade é obrigatório",
			},
			LabelInfoObjectType: "Selecione o tipo de objeto para a criação do ponto de visita.",
			GeoFindNextAddress: "O georreferenciador encontrou o seguinte endereço para as novas coordenadas:",
			UseAddressQuestion: "Você quer usar este endereço para o ponto de visita?",
			Success: {
				Title: "Ponto de visita criado",
				Text: "Um novo ponto de visita foi criado.",
			},
			ErrorRegisterValidate: {
				Title: "Campos ausentes",
				Text: "Campos ausentes em informações adicionais",
			},
			FindAddress: {
				Title: "Direção encontrada",
				Text: "Endereço georreferenciado com sucesso.",
			},
			ErrorFindAddress: {
				Title: "Endereço não encontrado",
				Text: "O georreferenner não encontrou o endereço inserido",
			},
			MissingAddress: {
				Title: "Endereço é necessário",
				Text: "O endereço é exigido pelo georreferenciador.",
			},
			ErrorFindCountry: {
				Title: "Cobertura não encontrada",
				Text: "Verifique se o país escolhido corresponde ao país para onde você está arrastando o marcador",
			},
			GeoRefFindAddress:
				"O georreferenciador encontrou um novo endereço para o novo  n O coordinates deseja substituir o endereço por",
			WithoutResource: "Você não atribuiu nenhum recurso, tem certeza de continuar?",
		},
		Edit: {
			VisitPointNotFound: {
				Title: "Ponto de visita não encontrado",
				Text1: "Registro de ponto de visita com id:",
				Text2: "não encontrado.",
			},
			AllVisitPoints: "Todos os pontos de visita",
			ValidMessages: {
				ObjectType: "O tipo de objeto é obrigatório",
				Name: "O campo nome é obrigatório",
				Identification: "O campo de identificação é obrigatório, sem caracteres especiais ou espaços",
				Phone: "O campo do telefone é obrigatório",
				Address: "O campo de endereço é obrigatório",
				Country: "O campo do país é obrigatório",
				Departament: "O campo do departamento é obrigatório",
				City: "O campo da cidade é obrigatório",
				Status: "O campo de status é obrigatório",
			},
			Success: {
				Title: "Visit Point Update",
				Text: "O ponto de visita foi atualizado com sucesso",
			},
			Error: {
				Title: "Erro de atualização",
				Text: "Ocorreu um erro durante a atualização",
			},
		},
		List: {
			CellRenderer: {
				DeleteRecord: "Você está prestes a deletar",
				DeleteSuccess: {
					Title: "Ponto de visita excluído",
					Text: "O ponto de visita selecionado foi excluído com sucesso",
				},
			},
			MassiveDelete: {
				Confirm: {
					Title: "Eliminação em massa",
					Text: "Tem certeza de continuar com a eliminação dos pontos de visita?",
				},
				Success: {
					Title: "Ponto de visita excluído",
					Text: "O ponto de visita selecionado foi excluído com sucesso",
				},
			},
			SelectVisitPoint: {
				Title: "Selecione os pontos de visita",
				Text: "Você não selecionou nenhum ponto de visita",
			},
			NotSchedule: "Não agendado",
			InvalidRangeOfDateTitle: "Intervalo de Datas Inválido",
			InvalidRangeOfDateMsj: "O intervalo de dias entre as datas não pode exceder 31.",
		},
		Assig: "Atribuir",
		AssignVisitPoints: "Atribuir pontos de visita",
		AssignedVisitPoint: "Ponto de visita atribuído",
		AssignedVisitPoints: "Pontos de visita atribuídos",
		NoAssignedVisitPoints: "Não há pontos de visita atribuídos",
		AssigneVisitPointText: "Selecione os pontos de visita que você deseja atribuir.",
		AssignedResourceByZonesTextAlert:
			"A alocação de recursos por zonas aos pontos de visita está ativa.Se você excluir recursos da lista, é possível que após salvar as alterações, alguns deles não sejam desmarcados devido a esta configuração",
		Colunms: "Colunas",
		ColumnsText: "Selecione as colunas que deseja renderizar na tabela",
		AssignVisitPointToltip: "Carregue a lista de pontos de visita disponíveis para continuar com a atribuição.",
		AssignAllVisitPointText: "Atribuir todos os pontos de visita da plataforma",
		TotalVisitPoints: "pontos totais de visita",
	},
	Activity: {
		Activity: "Atividade",
		AssignedResources: "Recursos Atribuídos",
		AssignedGroups: "Grupos Atribuídos",
		AssignedGroupsError: "Ocorreu um erro ao obter os grupos atribuídos.",
		AlertMissingForm: 'É necessário selecionar um formulário se a opção "Formulário Ativo" estiver ativada. ',
		AlertFormNotFoundTitle: "Formulário não encontrado.",
		AlertFormNotFoundText:
			"A atividade tem um formulário atribuído, mas não está na lista de formulários disponíveis.",
		ActivateForm: "Formulário Ativo",
		Form: "Forma",
		ServiceTime: "Tempo de serviço",
		Activated: "Ativada",
		Inactivated: "Inativada",
		ActivityListEmpty: "Não há atividades",
		ActivityHasNoAssignedResources: "A atividade não tem recursos atribuídos",
		Activities: "Actividades",
		AssignActivities: "Atribuir atividades",
		AssignedActivities: "Atividades atribuídas",
		LoadActivityListToltip: "Carregue a lista de atividades disponíveis para continuar com a atribuição.",
		TotalActivities: "Atividades totais",
		DRPointsRequired: "Dr Points necessários, mínimo 0 para continuar",
	},
	ActivityValidMessages: {
		ItemName: "O campo nome é obrigatório",
	},
	Schedule: {
		Schedules: "Horários",
		SelectionMode: "Modo de seleção",
		AdditionalFields: "Campos Adicionais",
		NotAdditionalFields: "O objeto não tem campos adicionais",
		AdditionalFieldsAlert:
			"Se você deseja adicionar ou editar campos adicionais, você deve selecionar um tipo de objeto.",
		AddNewVisit: "Visite as seleções",
		SelectResource: "Selecione o recurso",
		Refresh: "Atualizar",
		ResourceList: "Lista de Recursos",
		SearchSchedule: "Agenda de Pesquisa",
		CancelVisit: "Cancelar visita",
		ActivityNoAvailable: "Atividade não disponível para o recurso, vá para as atividades e atribua-a.",
		Repeat: "Repetir",
		CurrentVisitPointAssigned: "Ponto de visita atual atribuído",
		ToAssigVisitPoint: "Clique no botão de pesquisa para atribuir um.",
		ActiveApi: "Ativar Api",
		SchedulingApiNotEnabled: "API de agendamento não habilitada para esta empresa.",
		ServiformApiNotEnabled: "API de serviformes não habilitada para esta empresa.",
		Month: "Mês",
		Week: "Semana",
		Day: "Dia",
		ErrorProcess: {
			Title: "Erro",
			Text: "Ocorreu um erro durante o processo",
			InitHourError: "A hora de início não pode ser menor que a hora atual",
			VisitpointError: "O ponto de visita selecionado não está atribuído ao recurso seleccionado",
			ResourceActivityError: "A atividade selecionada não está atribuída ao recurso seleccionado",
		},
		SelectInitTime: "Selecione a hora inicial",
		SelectEndTime: "Selecione o horário de término",
		ValidEndOur: "A hora final não pode ser inferior à hora inicial.",
		ValidDinamicFields: {
			Text1: "O",
			Text2: "campo é obrigatório",
		},
		AssignVisitPointText: "Atribua um ponto de visita para criar o compromisso.",
		SelectVisitPointText: "Selecione o ponto de visita que você deseja atribuir ao compromisso.",
		SelectVisitPointTextAlarm: "Selecione o pontos de visita que você deseja atribuir ao alarme.",
		None: "NENHUM",
		Monday: "Segunda-feira",
		Tuesday: "Terça",
		Wednesday: "Quarta-feira",
		Thursday: "Quinta-feira",
		Friday: "Sexta-feira",
		Saturday: "Sábado",
		Sunday: "Domigo",
		MondayToFriday: "From segunda-feira to quinta-feira",
		EveryDay: "Todos os dias",
		MondayToSaturday: "DE SEGUNDA A SÁBADO",
		MondayAndFriday: "TERÇA-FEIRA E QUINTA-FEIRA",
		MondayWednesdayAndFriday: "SEGUNDA, QUARTA E SEXTA",
		Weekend: "FINAL DE SEMANA",
		WeekMayus: "Semanalmente",
		MonthMayus: "Mensalmente",
		Finished: "Finalizado",
		Finalize: "Finalizar Visita",
		InProgress: "Em Progresso",
		ReProgramming: "Reprogramado",
		Canceled: "Cancelado",
		Scheduled: "Agendado",
		InvalidFields: "Campos Inválidos",
		ValidData: {
			Title: "Valide os dados",
			Text: "Alguns campos importantes estão faltando",
			DayLessThanCurrentDayTitle: "Dia inválido",
			DayLessThanCurrentDay: "O dia da visita não deve ser inferior ao dia atual.",
		},
		SelectResourceText: "Selecione um recurso para ver os eventos no calendário",
		ListofEventsDay: "Lista de eventos para o dia selecionado",
		SelectDateToSeeEvents: {
			Text1: "Selecione os",
			Text2: "data",
			Text3: "para ver os eventos.",
		},
		EventsOnTheMap: "Eventos no mapa",
		Reassign: "Reatribuir visitas",
		ReassignTextConfirm:
			"Para reatribuir visitas com sucesso, o recurso selecionado deve ter as mesmas atividades atribuídas. Aceite para continuar.",
		ReassignTextError:
			"visitas não puderam ser reatribuídas, certifique-se de que o recurso selecionado tem as atividades necessárias atribuídas.",
		ReassignDate: "Nova reatribuição de data.",
		CreateVisit: "Criar visita",
		CreateVisits: "Criar visitas",
		OnTheWay: "No meu caminho",
		Delayed: "Atraso",
		NotAssigned: "Não atribuído",
		Visit: "Visita",
		ReassingResourceText: "Selecione um recurso da lista para reatribuir visitas",
		FilterVisitPointBy: "Filtrar pontos de visita por",
		ReviewVisits: "Rever visitas",
		DeleteVisit: "Excluir visita",
		DeleteVisitTextConfirm: "Você tem certeza de excluir a visita do sistema?",
		FilterByAdditionalFields: "Filtrar informações por campos adicionais",
		FilterByAdditionalFieldsText:
			"Selecione o tipo de objeto e atribua os valores a cada uma das propriedades pelas quais deseja filtrar as informações.",
		ReadyVisitsToAssign: "Visitas Prontas para Atribuir",
		ReadyVisitsToAssignText:
			"As seguintes visitas estão prontas para serem atribuídas ao recurso. Você pode excluí-las ou clicar no botão atribuir para concluir o processo.",
		NotReadyVisitsToAssign:
			"Não há visitas prontas para atribuir, complete as informações do formulário e clique no botão adicionar visita.",
		AddVisit: "Adicionar Visita",
		VisitInformation: "Informações da Visita",
		VisitInformationText: "Complete as informações da visita e clique no botão adicionar visita para continuar.",
		AssignResource: "Atribuir Recurso",
		AssignResourceText: "Selecione o recurso ao qual deseja atribuir a visita.",
		OpenAvailableResources: "Abrir Recursos Disponíveis",
		ClickToOpenAvailableResources: "Clique para abrir a lista de recursos disponíveis",
		ClickOnEditVisit: "Clique no botão editar para modificar as informações da visita.",
		UpdateVisitInformation: "Atualizar Informações da Visita",
		UpdateVisitInformationText:
			"Atualize as informações da visita e clique no botão reagendar para salvar as alterações.",
		RescheduleVisit: "Reagendar Visita",
		ConfirmActionQuestion: "Tem certeza de {n} a visita? Esta ação não pode ser desfeita.",
		VisitScheduling: "Agendamento de Visitas {n}",
		VisitSchedulingText:
			"Você pode agendar uma ou várias visitas de uma vez, complete as informações da visita e clique no botão adicionar visita.",
		VisitRescheduling: "Reprogramação de Visitas {n}",
		VisitReschedulingText:
			"Só é possível reprogramar uma visita de cada vez, atualize as informações da visita e clique no botão reagendar.",
		ScheduleVisits: "Agendar Visitas",
		ViewCalendar: "Ver Calendário",
	},
	DeleteGroup: {
		Text1: "Tem certeza que deseja deletar o grupo",
		Text2: "Aceite para continuar.",
	},
	GroupValidMessages: {
		ItemName: "O campo nome é obrigatório",
		ItemAddress: "O campo de endereço é obrigatório",
	},
	Groups: {
		Groups: "Grupos",
		TotalGroups: "Total de grupos",
		Group: "Grupo",
		AssigneGroup: "Atribuir Grupo",
		AssignGroups: "Atribuir Grupos",
		AssignedGroup: "Grupo Atribuído",
		AssignedGroups: "Grupos Atribuídos",
		AssigneGroupToltip: "Carregue a lista de grupos disponíveis para continuar com a atribuição.",
		ShowAssigneGroup: "Mostrar grupos atribuídos",
		NoAssignedGroups: "Não há grupos atribuídos",
		ShowAssigneGroupToltip: "Mostra a lista dos grupos atribuídos.",
		AssigneGroupRequired: "A atribuição do grupo é necessária",
		ClickOnButton: "Clique no botão",
		DeleteAllGroups: "Excluir todos os grupos",
		AvailableGroups: "Grupos disponíveis",
		Favorite: "Favorito",
		FavoriteConfirmText:
			"Definido como o grupo padrão para exibição de transmissão ao fazer login na plataforma, você pode visualizá-lo e alterá-lo rapidamente na barra superior",
		AskForAgain: "Pergunte novamente",
		DefaultGroup: "Grupo Padrão",
		FavoriteRemoveConfirmText:
			"Remova a opção de seleção de grupo padrão da barra superior da plataforma. Você pode ativá-lo novamente nas preferências da plataforma",
	},
	Alarm: {
		Alarm: "Alarme",
		Alarms: "Alarmes",
		BatteryAlarms: "Alarmes de bateria",
		RadioAlarm: "Alarme de início e fechamento de cronograma",
		Radio: "Raio",
		DefineRadius: "Estabelecer rádio",
		GpsAlarms: "Alarme GPS",
		UpdateAlarm: "Atualizar Alarme",
		CreateAlarm: "Criar Alarme",
		BatteryLevel: "Nível de bateria",
		AlarmList: "Lista de Alarmes",
		ScheduleAlarms: "Alarme de programação",
		TotalVisit: "Visitas totais",
		NoAssignedEmail: "Nenhum e-mail atribuído",
		ZoneAlarms: "Alarmes de zona",
		ZoneAlarmsType: "Tipo",
		SelectAll: "SELECIONAR TUDO",
		MissingFields: {
			Title: "Faltam campos",
			Text: "O nível da bateria deve ser maior que 0 e menor que 100",
		},
		ValidFields: {
			Name: "O campo nome é obrigatório",
			EndTime: "O campo do horário de término é obrigatório",
			Email: "O campo de e-mail é obrigatório e deve ser um e-mail válido",
		},
		SelectInitTime: "Selecione a hora inicial",
		SelectEndTime: "Selecione o horário de término",
		AssignedResources: "Recursos Atribuídos",
		AssignedZones: "Zonas atribuídas",
		AddResources: "Adicionar Recursos",
		LoadListResources: "Carregue a lista de recursos a serem atribuídos ao alarme.",
		DeleteResources: "Apagar Recursos",
		DeleteAllResources: "Exclua todos os recursos.",
		DeleteAllVisitPoints: "Exclua todos os pontos de visita.",
		AssignedEmails: "Emails atribuídos",
		DeleteEmails: "Remover e-mails",
		DeleteAllEmails: "Apagar todos os e-mails",
		NotAssignEmail: "Nenhum e-mail atribuído",
		DeleteAllText: "Você está prestes a deletar todos",
		ErrorGetResourceFilter: {
			Title: "Erro",
			Text: "Ocorreu um erro ao consultar os recursos atribuídos.",
		},
		DeleteYouAre: "Você está prestes a apagar",
		MissingFieldsSchedule: {
			Title: "Faltam campos",
			Text: "O número total de visitas deve ser maior que 0",
			Text2: "A zona é um valor obrigatório",
		},
		ZoneTypes: {
			Input: "Entrada",
			Output: "Saída",
			InputAndOutput: "Entrada e saída",
		},
		TitleConfirmAlarmCreate: "Alarme Criado",
		TextConfirmAlarmCreate: "O alarme foi criado com sucesso",
		TitleConfirmAlarmDelete: "Alarme Excluído",
		TextConfirmAlarmDelete: "O alarme selecionado foi excluído com sucesso",
		TitleConfirmAlarmUpdate: "Alarme Atualizado",
		TextConfirmAlarmUpdate: "O alarme selecionado foi atualizado com sucesso",
		ValidInitHour: "A hora inicial não pode ser maior ou igual à hora final.",
		ValidEndHour: "O horário de término não pode ser menor ou igual ao horário de início.",
		DateInitError: "A data de início não pode ser posterior à data de término.",
		AssignateTo: "Atribuir alarme a",
		EventToNotify: "Tipo de evento para notificar",
		Start: "Começo do visitas",
		End: "Fechamento de visitas",
		Startandend: "Início e fim das visitas",
		SpeedAlarm: "Alarme de Velocidade",
		Speed: "Velocidade",
		ValidSpeed: "A velocidade deve estar entre 1 e 200",
		ValidSpeedRequired: "O campo velocidade é obrigatório",
	},
	Zonification: {
		Zonification: "Zonificação",
		View: "Visualizar",
		Draw: "Desenhar",
		ReplacePolygonConfirmTitle: "Substituir Polígono",
		ReplacePolygonConfirmText: "Tem certeza de que deseja substituir o polígono da zona atualmente selecionada?",
		Tools: "Ferramentas",
		AlertTextOne: "Selecione o recurso que irá associar às zonas através da opção",
		DeleteZoneResourceConfirmTitle: "Excluir Atribuição",
		DeleteZoneResourceConfirmText:
			"Tem certeza de que deseja excluir todas as zonas atribuídas com este recurso? Aceite para continuar.",
		DeleteAssignationSuccess: "Atribuição foi excluída",
		DeleteAssignationSuccessText: "Todas as zonas foram desatribuídas com êxito do recurso.",
		CreateAssignationSuccess: "Atribuição Criada",
		CreateAssignationSuccessText: "A atribuição de zonas foi criada com sucesso.",
		UpdateAssignationSuccess: "Atualização de atribuição",
		UpdateAssignationSuccessText: "A atribuição de zonas foi atualizada com sucesso.",
		AlertSelectLayerTitle: "Selecione Camada e Zonas",
		AlertSelectLayerText:
			"Agora selecione uma camada para ver a lista de zonas disponíveis para atribuir ao recurso selecionado.",
		AlertSelectLayerText2: "Use o botão",
		AlertSelectLayerText3: "para salvar as alterações feitas ou ",
		AlertSelectLayerText4: "para excluir as atribuições atuais.",
		Zone: "Zona",
		Zones: "Zonas",
		ZonesNotFound:
			"Nenhuma informação sobre as zonas atribuídas foi encontrada ou elas foram removidas do sistema.",
		AssignedZone: "Zona Atribuída",
		Circle: "Círculo",
		Rectangle: "Retângulo",
		Polygon: "Polígono",
		Polyline: "Polilinha",
		Marker: "Marcador",
		FillColor: "Cor de preenchimento",
		NewLayer: "Nova camada",
		EditInfo: "Editar informação",
		RemoveZones: "Remover Zonas",
		Layer: "Camada",
		EditName: "Editar nome",
		Layers: "Camadas",
		UseTool: "Use a ferramenta",
		DrawAndAddZones: 'Para desenhar e adicionar zonas à camada, que serão listadas na lista suspensa "Zonas"',
		AssignNameLayer: "Atribua um nome de camada.",
		NameLayer: "Nome da camada",
		EditZoneSelected: "Informações da área selecionada, atribua um novo nome ou uma descrição.",
		AddZoneInLayer: "Para adicionar esta área à camada, atribua um nome e uma descrição",
		AddZone: "Adicionar Zona",
		CreateNewLayer: "Criar nova camada",
		UpdateNameLayer: "Camada de nome de atualização.",
		DragToRelocate: "Arraste para realocar",
		CurrentPosition: "Posição atual",
		UpdateLayerSuccess: {
			Title: "Camada Atualizada",
			Text: "O nome da camada é atualizado corretamente.",
		},
		RemoveLayer: {
			Title: "Camada removida",
			Text: "Camada removida com sucesso.",
		},
		UpdateZone: {
			Title: "Zona Atualizada",
			Text: "A área da zona foi modificada com sucesso",
			Text2: "A informação da zona foi atualizada com sucesso.",
		},
		AddZones: {
			Title: "Zona Adicionada",
			Text: "Nova zona adicionada à camada atual.",
		},
		ErrorInsertZones: {
			Title: "Adicionar erro",
			Text: "Ocorreu um erro ao adicionar a nova área à camada, tente novamente.",
		},
		ErrorRemoveZones: {
			Title: "Falha na exclusão",
			Text: "Ocorreu um erro durante a eliminação de zonas, tente novamente.",
		},
		RemoveLayerMessage: {
			Title: "Camada Removida",
			Text: "A camada e todas as suas zonas foram removidas corretamente.",
		},
		RemoveZoneMessage: {
			Title: "Zona Removida",
			Text: "As zonas selecionadas foram removidas corretamente.",
		},
		RemoveZonesInLayer: {
			Title: "Camada removida",
			Text: "A camada e todas as suas zonas foram excluídas com sucesso.",
		},
		ErrorRemoveZonesInLayer: {
			Title: "Erro ao remover",
			Text: "Ocorreu um erro durante a eliminação de todas as zonas da camada, tente novamente.",
		},
		RemoveLayerConfirmation: {
			Title: "Remova a camada.",
			Text: "Tem certeza de que excluiu toda a camada e suas respectivas zonas?",
		},
		ErrorUpdateZoneInfo: {
			Title: "Erro ao atualizar",
			Text: "Erro durante a atualização das informações, tente novamente.",
		},
		SelectZones: {
			Title: "Selecione Zonas",
			Text: "Você não selecionou nenhuma zona.",
		},
		ConfirmRemoveLayerAndZones: {
			Title: "Confirme a eliminação",
			Text: "Tem certeza de que deseja eliminar toda a camada e respectivas zonas?",
		},
		ConfirmRemoveSelectedZones: {
			Title: "Confirme a eliminação",
			Text: "Tem certeza de que deseja excluir todas as áreas selecionadas?",
		},
		UploadZones: {
			SelectFileText: "Selecione um arquivo para iniciar o carregamento",
			FileName: "Selecione o arquivo",
			Success: {
				Title: "Sucesso no upload",
				Text: "O arquivo foi carregado com sucesso",
			},
			Error: {
				Title: "Erro de upload",
				Permission: "O usuário não tem permissão para acessar o objeto",
				Cancel: "O usuário cancelou o upload",
				Unknown: "Ocorreu um erro desconhecido, inspecione error.serverResponse",
			},
		},
		FormGeo: {
			FindCoords: "O georreferenciador encontrou o seguinte endereço para as novas coordenadas:",
			AskUseDirection: "Você quer usar este endereço para o ponto de visita?",
			FindDirection:
				"O georreferenciador encontra uma nova direção para as novas coordenadas \n Você deseja substituir o endereço por",
		},
	},
	UploadFiles: {
		UploadFiles: "Fazer upload de arquivos",
		UploadSuccess: "Sucesso no upload",
		UploadSuccessMessage: "O arquivo foi carregado com sucesso.",
		UploadError: "Erro de upload",
		UploadErrorMessage:
			"Ocorreu um erro durante o upload do arquivo, verifique se o arquivo possui a estrutura básica ou baixe os arquivos de exemplo",
		UploadType: "Tipo de upload",
		UploadTypeSelectToltip: "Define o tipo de upload do arquivo",
		UploadTypeObjectToltip:
			"Define a estrutura do arquivo a ser carregado levando em consideração seus campos adicionais.",
		UploadTypeCountryTooltip: "Selecione o país onde serão georreferenciados os pontos de visita a carregar.",
		SelectFile: "Selecione o arquivo",
		UploadSuccessTextAlert:
			"O arquivo foi carregado com sucesso e está sendo processado em segundo plano, verifique ou aguarde as notificações do sistema para saber o status do processo.",
		FileReadyToBeUploaded: "Arquivo pronto para ser carregado.",
		Details: "Detalhes",
		Size: "Tamanho",
		DownloadFailed: "Falha no download",
		DownloadFailedText: "Falha no download, arquivo não encontrado ou foi removido do servidor",
		FileNotFound: "Arquivo não encontrado",
		DownloadFormat: "Baixar arquivo básico",
		DownloadFormatText:
			"Baixe um arquivo base ou modelo no formato selecionado que contém a estrutura necessária para o tipo de upload selecionado",
		Format: "Formato",
		InvalidFormatFile: "Arquivo de formato inválido",
		InvalidFormatFileText:
			"Selecione um arquivo com o formato correto para continuar com o upload. Somente arquivos .xlsx, .xls, .csv, .json ou .xml são permitidos",
	},
	Reports: {
		Report: "Relatório",
		Reports: "Relatórios",
		GenerateReport: "Gerar um relatório",
		GenerateReportInfo: "Para gerar um novo relatório, selecione o tipo de relatório que deseja gerar",
		AlertTextOne: "Selecione os recursos associados ao relatório através da opção",
		AlertTextTwo: "para continuar com o processo.",
		NoDataReportTitle: "Nenhum dado encontrado",
		NoDataReport: "Nenhum dado encontrado para este tipo de relatório.",
		NoDataReportInDates: "Não foram encontrados dados para as datas estabelecidas.",
		ReportGeneratedTitle: "Relatório Gerado",
		ReportGeneratedText: "O relatório foi gerado com sucesso.",
		loginout: "Entrar e sair",
		scheduledroute: "Rota Agendada",
		scheduledroutevsexecuted: "Rota programada vs executada",
		location: "Localização",
		LocationDescription: "Este relatório retorna a última posição dos recursos",
		historicalposition: "Histórico de Posições",
		HistoricalpositionDescription: "Este relatório exporta todas as posições onde o recurso foi transmitido",
		transmission: "Transmissão",
		TransmissionDescription: "Este relatório retorna o tempo total de transmissão em um dia útil.",
		EndDateLessToday: "A data de término deve ser menor que hoje",
		DateRequired: "Campos ausentes, data obrigatória",
		RangeExceeds: "intervalo de datas excede noventa (90) dias",
		EndDateGreaterInitDate: "A data de término deve ser maior que a data inicial",
		EndDateGreaterOrEqualInitDate: "A data de término deve ser maior ou igual à data inicial",
		DateInitMustBeLessToday: "Para este tipo de relatório, a data deve ser menor que hoje",
		General: "Relatório Geral de Recursos",
		Single: "Relatório de recurso único",
		Multiple: "Relatório de múltiplos recursos",
		AlertTextLogin: "O relatório geral não precisa de atribuições de recursos",
		Generate: "Gerar",
		History: "História",
		DeleteAllText: "Tem certeza de que deseja excluir todos os recursos?",
		SelectFileTitle: "Gerar Relatório",
		SelectFile: "Selecione o tipo de arquivo",
		Error: "Um erro ocorreu. Por favor, tente novamente!",
		ShowFiles: "Mostrar Arquivos",
		FileName: "Nome do Arquivo",
		TotalFiles: "Total Arquivos",
		DownloadReports: "Histórico de Relatórios",
		MaxResourcesReached: "este tipo de relatório não pode ser gerado para mais de 10 recursos",
		ReportType: "Tipo de Relatório",
		ProcessingReport: "Processando um relatório",
		HistoricalpositionText:
			"Este relatório é processado em segundo plano e a plataforma irá notificá-lo de seu status através do módulo de notificação na parte superior",
		ReportProcessFinish:
			"Agora, você pode encontrar o arquivo de resultado no relatório de histórico para baixá-lo",
		ReportSetDateRange: "Estabeleça um intervalo de datas: Para o relatório selecionado no máximo' é permitido,",
		ReportSetFileType: "Selecione o tipo de arquivo que deseja gerar",
		visitpoint: "Pontos de Visita",
		VisitpointReportDescription:
			"Este relatório retorna as informações dos pontos de visita selecionados, dividindo os dados em arquivos separados por tipo de objeto",
		MultipleVisitPoints: "Relatório de vários pontos de visita",
		resource: "Recursos",
		ResourceReportDescription:
			"Este relatório retorna as informações dos recursos selecionados, dividindo os dados em arquivos separados por tipo de objeto",
		id: "ID",
		report_type: "Tipo de Relatório",
		date_init: "Data de Início",
		date_end: "Data de Término",
		resource_id: "ID do Recurso",
		added_on: "Adicionado em",
		update_on: "Atualizado em",
		total_download_file: "Total de Arquivos Baixados",
		download_file_id: "ID do Arquivo Baixado",
		sort_by: "Ordenar por",
		sort_by_description:
			"Selecione o(s) campo(s) pelos quais deseja ordenar a lista de relatórios, com os campos selecionados tendo prioridade da esquerda para a direita",
		sorting_type: "Tipo de Ordenação",
		ascendent: "Ascendente",
		descendent: "Descendente",
		filter_by: "Filtrar por",
	},
	Indicators: {
		Indicators: "Indicadores",
		IndicatorList: "Lista de Indicadores",
		CreateIndicator: "Criar Indicador",
		TitleConfirmIndicatorCreate: "Indicador Criado",
		TextConfirmIndicatorCreate: "O indicador foi criado com sucesso",
		TitleConfirmIndicatorDelete: "Indicador Excluído",
		TextConfirmIndicatorDelete: "O indicador selecionado foi excluído com sucesso",
		TitleConfirmIndicatorUpdate: "Indicador Atualizado",
		TextConfirmIndicatorUpdate: "O indicador selecionado foi atualizado com sucesso",
		DeleteIndicator: "Tem certeza que deseja excluir este indicador? Por favor aceite para continuar",
		UpdateIndicator: "Indicador de atualização",
		Visualizer: "Visualizar",
		AlertVisualizar: "Indicador do Visualizador",
		AlertVisualizarInfo: "Para ver um indicador, clique em um item da lista que você deseja ver.",
		IndicatorNotFound: "Não há indicadores ou não existe",
		Indicator: "Indicador",
	},
	Communication: {
		Communication: "Comunicação",
		Message: "Mensagem",
		Messages: "Mensagens",
		NewMessage: "Nova mensagem",
		MessageReply: "Escreva sua mensagem de resposta aqui",
		Seen: "Visto",
		Unseen: "Não visto",
		MarkAs: "Marca como",
		Resolved: "Resolvido",
		PendingForResolved: "Pendente para resolvido",
		AlertVisualizarInfo:
			"Para ver as mensagens, clique em um item da lista de recursos para o qual deseja ver suas mensagens.",
		NoMessages: "Não há mensagens.",
		NoMessagesText: "O recurso selecionado não possui nenhuma mensagem.",
		DeleteMessages: "Apagar mensagens",
		DeleteMessagesText: "Tem certeza que deseja excluir as mensagens selecionadas? Aceite para continuar.",
		WaitingToResolve: "Pendente para resolver",
		UnresolvedMessages: "Mensagens não resolvidas",
	},
	Notification: {
		Notification: "Notificação",
		Notifications: "Notificações",
		DeleteAllNotifications: "Apagar todas as notificações",
		UPLOAD_FILE: "Notificações sobre o upload do arquivo",
		DOWNLOAD_FILE: "Notificações sobre o download do arquivo",
		EVENT: "Notificações sobre o calendário",
		New: "Nova",
		NewNotification: "Novas Notificações",
		AppNotifications: "Notificações de aplicativo",
		NEW_EVENT: "NOVO EVENTO",
		EVENT_NOT_ASSIGNED: "EVENTO NÃO ATRIBUÍDO",
		RESCHEDULED_EVENT: "EVENTO REAGENDADO",
		EVENT_IN_PROCESS: "EVENTO EM PROCESSO",
		EVENT_ENDED: "EVENTO ENCERRADO",
		EVENT_CANCELLED: "EVENTO CANCELADO",
		EVENT_ON_THE_WAY: "A CAMINHO DA VISITA",
		EVENT_DELAYED: "DEMORANDO PARA VISITAR",
		FINALIZED: "PROCESSO FINALIZADO",
		LOADED: "ARQUIVO CARREGADO",
		PROCESS: "ARQUIVO ESTÁ EM PROCESSO",
		DOWNLOAD_FINALIZED: "Download Concluído",
		PANIC_ALARM: "Alarme de pânico",
		PanicAlarmText: "Um alarme de pânico foi relatado por um dos recursos no campo",
		CheckOut: "Verificar",
	},
	Login: {
		Subtitle: "Bem-vindo, faça o login para usar a plataforma.",
		Email: "Email",
		Password: "Contra-senha",
		Remember: "Lembre de mim",
		ForgotPassword: "Esqueceu sua senha?",
		Register: "Registro",
		Disabled: "A conta do usuário foi desabilitada por um administrador.",
		Login: "Conecte-se",
		PasswordWasRestored: "A senha foi restaurada com sucesso",
		PasswordIsNotSecure: "A senha não é segura digite outra",
		EmailDoesNotExist: "O e-mail não existe ou não tem um uid associado",
		PleaseVerifyCode: "Por favor, verifique o código",
		PasswordIsNotsecure: "A senha não é segura, digite outra",
		LoginAttemptTitle: "Tentativa de login",
		LoginAttemptText: "¡Você já está logado!",
		ValidMessages: {
			Email: "O campo Email é obrigatório e deve ser um email válido",
			Password: "A senha é obrigatória, mínimo de 6 caracteres - máximo de 18",
			text: " mínimo 6 personagens - máximo 18",
			InvalidPassword: "A senha é inválida ou o usuário não tem uma atribuída",
			UserNotFound: "Alguma coisa deu errado ao validar as credenciais",
			TooManyRequests:
				"O acesso a esta conta foi temporariamente desativado devido a muitas tentativas de login com falha. Você pode restaurá-la imediatamente redefinindo sua senha ou pode tentar novamente mais tarde.",
			CompanyReachedWorkingDate: "A empresa atingiu a data de trabalho",
			InvalidCode: "Código de autenticação inválido",
		},
		LoginWithGoogle: "Login com conta do Google",
		EnableTwoFactorAuthentication: "Habilitar autenticação de dois fatores",
		TwoFactorAuthentication: "Autenticação de dois fatores",
		TwoFactorAuthenticationText:
			"Digite o código de 6 dígitos que lhe foi enviado por e-mail para continuar com a autenticação",
		ResendAuthCodeEmail: "Se a mensagem com o código de autenticação não chegou, você pode solicitar um reenvio.",
		ResendCode: "Reenviar código",
		CodeSent: "Código de verificação enviado",
	},
	RecoverPassword: {
		Title: "Recuperar senha",
		Subtitle: "Insira seu endereço de e-mail e enviaremos instruções sobre como redefinir sua senha.",
		Email: "Email",
		ToLogin: "Entrar",
	},
	ResetPassword: {
		TitleReset: "Redefinir senha",
		TitleCreate: "Criar senha",
		Subtitle: "Por favor insira sua nova senha.",
		VerificationCode: {
			Title: "Código de verificação",
			Text1: "Um código de verificação foi enviado para o e-mail. se o código não chegar,",
			Text2: "mande de novo",
		},
		Code: "Código",
		YourPassword: "Sua senha",
		ConfirmPassword: "Confirme a Senha",
		ToLogin: "Entrar",
		Reset: "Redefinir",
		ValidPassword1: "O campo da senha deve ter pelo menos 6 caracteres",
	},
	CompanyForm: {
		nameRequired: "O nome do campo é obrigatório",
		addressRequired: "O campo endereço é obrigatório",
		phoneRequired: "O telefone de campo é obrigatório",
		nitRequired: "O nit da empresa de campo é obrigatório",
		date_initRequired: "O campo data init é obrigatório",
		date_endRequired: "O campo data de término é obrigatório",
		contac_personsRequired: "O campo de contato de pessoas é obrigatório",
		cityRequired: "O campo cidade é obrigatório",
		countryRequired: "O país do campo é obrigatório",
		descriptionRequired: "A descrição do campo é obrigatória",
		InvalidFields: "Campos Inválidos",
		ChechInfo: "Verifique as informações, se estiverem corretas, clique no botão Salvar para finalizar o processo.",
		ViewCompanyList: "Clique aqui para ir para a lista de empresas",
		AdminResource: "Recurso de Administrador",
		AdminResourceSuccess: "O recurso de administrador foi criado com sucesso",
		AdminResourceError: "Recurso de administrador não pôde ser criado",
		AdminResourceFailed:
			"Algo deu errado durante a criação do recurso de administrador. tente criá-lo novamente a partir da lista de empresas.",
		DateInitError: "A data de início não pode ser posterior à data de término.",
		CompanyInformation: "Informações da Empresa",
		Summary: "Resumo",
		Finish: "Terminar",
		ActivateServiroutes: "Selecione o recurso de administrador para a ativação de Serviroutes.",
		ActivateSitidadaText1: "É necessário ativar o SITIDATA para o correto funcionamento da plataforma",
		ActivateSitidadaText2: "clique aqui para adicionar configuração.",
		RequiredConfig: "Configurações Requeridas",
		EmailAlreadyExist: "Já existe um usuário registrado com este e-mail",
		ValidEmail: "Email válido",
		ReleationShip: "Relacionamento com pontos de visita",
	},
	ManualData: {
		Required: "Obrigatório",
		InformationFound: "Informação encontrada",
		ErrorsFound: "Erros encontrados durante o processo de upload de informações",
		ErrorsNotFound: "Nenhum erro encontrado durante o processo de upload de informações",
		ValidatorRequiredProperty: "é uma propriedade obrigatória, remova-a",
		AlreadyRegistered: "Já registrado",
		DateLessThanCurrentDate: "Data anterior à data atual",
		NotRegistered: "Não registrado",
		ValidatorAdditionalProperties: "Propriedades adicionais não são permitidas, exclua-as",
		TooShortProperties: "O valor da propriedade está vazio ou o conteúdo é muito curto",
		country: "País",
		city: "Cidade",
		address: "Endereço",
		identification: "Identificação",
		phone: "Telefone",
		name: "Nome",
		cx: "CX",
		cy: "CY",
		date: "Date",
		ManageError: "Gerenciar erros",
		ProcessAgain: "Processo de novo",
		ProcessAgainText:
			"Reprocesse o arquivo; isso tentará criar novos registros no sistema, portanto, observe que os registros não devem existir.",
		ProcessAgainTextSuccess:
			"Reprocessar o arquivo está funcionando em segundo plano, verifique ou aguarde as notificações do sistema para saber o status do processo.",
		DownloadFile: "Fazer download do arquivo",
		Download: "Baixar",
		AddedOn: "Adicionado",
		PropertyError: "Erro na propriedade",
		ShowErrors: "Mostrar erros",
		FixErrorsHere: "Corrija os erros aqui",
		FixErrorsModule: "Corrigir erros no módulo",
		SaveChanges: "Salvar alterações",
		ActivityNotRegistered: "Atividade não registrada",
		EditAlertText:
			"Edite a propriedade selecionada, respeite seu formato e observe que alguns valores devem existir.",
		Property: "Propriedade",
		ResourceHasNoActivities: "O recurso não tem atividades",
		SaveRecordError: "Erro ao salvar registro",
		DaneCodeNotFound: "Código Dane não encontrado",
		DuplicateRecordInExcel: "Registro duplicado no excel",
		InitHourLessThanCurrentTime: "Hora inicial menor que a hora atual",
		ErrorEndHour: "Erro na hora de término",
		ErrorInitHour: "Erro na hora inicial",
		ErrorDate: "Erro na data",
		CoordinatesCouldBeNotFound: "Coordenadas não encontradas",
		AddressCouldBeNotGeoreferenced: "O endereço não pôde ser georreferenciado",
		TimeDataFormat:
			"O formato não é válido, o formato correto deve ser semelhante para data AAAA-mm-dd ou hora HH: mm: ss",
		SitidataGeoreverseToken: "O token georeverso da API Sitidata não está habilitado para este país",
		InvalidValue: "tem um valor inválido, apenas cadeias de caracteres são permitidas",
	},
	Record: {
		ListRecord: "Lista de Registros",
		RecordNumber: "Número recorde",
		UpdateRecord: "Atualizar registro",
		CreateRecord: "Criar registro",
		DeleteRecord: "Apagar registro",
		DeleteRecordConfirmText: "Tem certeza de que deseja excluir este registro do sistema? Aceite para continuar.",
		TitleConfirmRecordCreate: "Registro Criado",
		TextConfirmRecordCreate: "O registro foi criado com sucesso",
		TitleConfirmRecordDelete: "Registro excluído",
		TextConfirmRecordDelete: "O registro selecionado foi excluído com sucesso",
		TitleConfirmRecordUpdate: "Registro Atualizado",
		TextConfirmRecordUpdate: "O registro selecionado foi atualizado com sucesso",
	},
	Routing: {
		Optimization: "Otimização",
		Resource: "Recurso",
		Routing: "Pontos de visita da rota",
		DistanceRoute: "Distância",
		MinimumRouteTime: "Tempo de rota",
		Typology: "Tipologia",
		SelectedColumns: "Colunas Selecionadas",
		DeparturePointOptionsTex: "Selecione uma das opções para adicionar um ponto inicial e um ponto final",
		DeparturePoint: "Ponto de Partida",
		StartingPoint: "Ponto de inicio",
		FinalPoint: "Ponto final",
		FromMapTitle: "Selecione um ponto no mapa clicando na posição desejada ou arrastando o marcador",
		FromMapAlert: "Selecione um ponto no mapa clicando na posição desejada",
		FromMap: "Habilita a função de poder selecionar um ponto do mapa clicando onde quiser",
		FromVisitPoint: "Permite atribuir o ponto da lista de pontos de visita do sistema",
		FromGroup: "Permite atribuir o ponto da lista de grupos de sistemas",
		FromAdditionalFields:
			"Permite que você atribua o ponto dos campos de tipo de localização adicionais dos objetos",
		Point: "Ponto",
		NoFoundDefaultPoint:
			"Nenhum ponto inicial padrão encontrado para o recurso, configure um através da opção Add Point",
		ConfigureInitHour: "Defina um horário de início para otimização e clique no botão continuar",
		AcceptOptimization:
			"Isso atualizará todos os eventos do calendário com as informações propostas pela otimização",
		SuccessOptimization: {
			TextOne: "Otimização concluída com sucesso, revise o resultado",
			TextTwo: "clique aqui",
			TextThree: "ou no botão",
			TextFour: "para aceitar a resultado e atualizar os eventos no calendário",
		},
		ErrorOptimization:
			"Ocorreu um erro durante a otimização. Tente novamente. Se o erro persistir, entre em contato com o administrador da plataforma",
		DateLessThanCurrentDate: "A data de otimização não pode ser menor que a data atual",
		RescheduledEvents: "Eventos Reagendados",
		RescheduledEventsText: "Os eventos foram reagendados com sucesso",
		OverlapEventsWarning:
			"Para evitar a sobreposição do calendário, algumas visitas tinham datas agendadas para dias posteriores, verifique as visualizações destacadas",
		Buttons: {
			Process: "Rota de Processo",
			Next: "Próxima",
			Optimize: "Otimize",
			SeeRoute: "Ver Rota",
			Validate: "Validar",
			OtherFields: "Adicionar a outros campos",
			AddVisitPoint: "Adicionar Ponto de Visita",
			EditVisitPoint: "Editar",
			NextResources: "A seguir, selecione os recursos",
			ExportRoute: "Rota de exportação",
			SeeAllRoutes: "Ver Rotas",
			Schedule: "Programar",
			DeleteRoute: "Excluir rota",
		},
		Table: {
			Type: "Tipo",
			Name: "Nome",
			AddedOn: "Adicionado",
			Action: "Açao",
			Actions: "Ações",
			Identification: "Identificação",
			Longitude: "Longitude",
			Latitude: "Latitude",
			EstimatedTimeArrival: "Tempo estimado de chegada",
			TimeService: "Tempo de serviço",
			TimeWindowInit: "Tempo inicial",
			TimeWindowEnd: "Fim do tempo",
			Cx: "Latitude",
			Cy: "Longitude",
			Demand: "Demanda",
			InitHour: "Hora inicial",
			EndHour: "Hora de Fim",
			Skills: "Habilidades",
			Row: "Linha do Excel",
			Column: "Coluna do Excel",
			Error: "Erro",
		},
		Title: {
			ResourceList: "Lista de Recursos",
			VisitPointsList: "Lista de pontos de visita",
			SelectFormat: "Selecione o formato",
			Close: "Fechar",
			MatchColumn: "Coluna de correspondência",
			TableExample: "Exemplo de dados de arquivo carregado",
			TableExampleText: "Abaixo está uma prévia dos dados encontrados no arquivo carregado",
			ProcessVisitPoints: "Pontos de visita de processo",
			EditVisitPoint: "Editar Ponto de Visita",
			VisitPoints: "Todos os seus pontos de visita",
			VisitPointsLocations: "Locais dos pontos de visita",
			Resources: "Recursos",
			OptimizeByTeam: "Filtrar por equipe",
			SelectResource: "Selecione os recursos para exportar a rota",
			Errors: "Erros encontrados",
			UploadVisitpoints: "Carregar pontos de visita",
			UploadVisitpointsList: "Listar arquivos carregados",
			ExportFromDataRutas: "Exportar Pontos de Visita Rutify",
			RoutingHistory: "Histórico de Roteamento",
			Schedule: "Cronograma",
			RoutingMode: "Selecione o tipo de roteamento",
			Basic: "Básico",
			Logistic: "Logística",
			Selection: "Seleção",
			AssignBulkActivity: "Atribuir atividade em massa",
			AssignActivity: "Atribuir atividade a todos os pontos de visita marcados.",
		},
		Map: {
			MapAppearance: "Aspecto do mapa",
			Types: "Tipo de mapa",
			Styles: "Estilo de Mapa",
			ClickToDownload: "Clique para fazer o download",
			ShowMap: "Mostrar mapa",
			HideMap: "Esconder mapa",
			ExportRoute: {
				Error: "A rota não pôde ser exportada",
				Success: "Rota exportada com sucesso",
			},
			Schedule: {
				OptionalDate: "Data (opcional)",
				ClickToSchedule: "Clique para agendar",
				Success: "Solicitação de agendamento enviada, para verificar usar o calendário Rutify",
				Error: "Ocorreu um erro e sua programação não foi enviada",
			},
			VisitPoints: {
				Drop: "Ponto de visita de queda",
				Dropped: "Ponto de visita abandonado",
				Identifier: "Identificador",
				TimeArrival: "Tempo de chegada",
				Deposit: "Depósito",
			},
			DeleteRoute: {
				DeleteRouteAsk: "Tem certeza de que deseja excluir a rota atual?",
				Success: "Rota removida com sucesso",
			},
		},
		RouteResult: {
			Title: "Resultado da rota",
			ResourcesRouted: "Recursos encaminhados",
			ResourcesNotRouted: "Recursos não encaminhados",
			RoutesTime: "Tempo mínimo total em todas as rotas",
			TotalDistance: "Distância total",
			VisitPointsRouted: "Pontos de Visita Roteados",
			VisitPointsNotRouted: "Pontos de visita não roteados",
		},
		Messages: {
			upload_placeholder: "Arraste seus arquivos aqui ou clique para adicionar um arquivo",
			MatchColumn:
				"Chaves e valores equivalentes aos nomes das colunas dados no arquivo a ser processado, para roteamento.",
			MatchColumnSelectionRouting:
				"Mapeamento de equivalências entre colunas encontradas no arquivo e as propriedades exigidas pelo processo de roteamento.",
			MatchColumnSelectionRoutingP2:
				"Ao lado de cada nome de coluna encontrado no arquivo, selecione o valor correspondente ao equivalente da carga.",
			MatchColumnSelectionRoutingP3:
				"Através da opção adicionar da lista, podemos adicionar as colunas como valores adicionais ao resultado do processo de roteamento, as demais colunas serão omitidas.",
			MatchColumnSelectionRoutingP4:
				"Assim que a atribuição for concluída, clique no botão Salvar para continuar com a seleção no mapa.",
			MatchColumnSelectionRoutingError: "As seguintes equivalências a serem atribuídas estavam faltando: ",
			MatchColumnSelectionRoutingErrorTitle: "Erro de Equivalências",
			MatchColumnSelectionRoutingErrorEquivalents: "É necessário atribuir as equivalências das colunas",
			SelectedColumns:
				"Nomes de colunas que você deseja manter e que aparecem na resposta de roteamento; o restante dos campos será omitido.",
			ErrorMsg: "Corrija esses erros em seu arquivo Excel e tente carregá-lo novamente.",
			AlertRoutingHistory:
				'Lembre-se de que você pode reotimizar uma rota carregada anteriormente, usando a função "otimizar" e selecionando novos recursos.',
			AlertProccessing: "Estamos trabalhando para otimizar seu roteamento, avisaremos quando estiver concluído.",
			SelectSchedule: "Selecione seus recursos para agendar",
			DataRutasVisitPointsSelect:
				"Esta é a sua lista de pontos de visita no Rutify, para rotear usando esses pontos, selecione-os e escolha um tipo de rota",
			AssignEquivalents: "Atribuição de equivalência de coluna",
		},
	},
	RoutesLegends: {
		ProgramedRoutes: "Rotas programadas",
		ExecutedRoutes: "Rotas Executadas",
		TotalVisits: "Visitas totais",
		Distance: "Distância",
		Time: "Tempo",
		ViewZones: "Visualize as zonas atribuídas aos recursos.",
		SpeedReached: "Velocidade Atingida",
	},
	Statistics: {
		Statistics: "Estatisticas",
		VisitsStatistics: "Estatísticas de visitas para o mês exibidas no calendário",
	},
	Setting: {
		Setting: "Ajustes",
		NewConfiguration: "Nova Configuração",
		VisualSetting: "Ajustes Visuais",
		ThemeColor: "Cor do Tema",
		NavbarColor: "Cor da barra de navegação",
		ConfirmSave: "¿Você quer salvar as alterações aplicadas?",
		Saved: "Alterações salvas com sucesso.",
		SelectCompany: "Selecione a empresa para configurar",
		AllowedLogo: "Arquivos de imagem permitidos JPG ou PNG. Tamanho máximo de 900kB",
		ImageNotAllowed: "Imagem não permitida",
		ChooseImage: "Escolher imagem",
		UploadImage: "Upload Imagen",
		DeleteImage: "¿Tem certeza de excluir a imagem?",
		ImagenUploaded: "A imagem foi enviada com sucesso",
	},
	OnDemand: {
		OnDemand: "Sob Demanda",
		AssigResource: "Atribuir recurso",
		SearchResources: "Encontrei recursos",
		Automatically: "Automaticamente",
		Manually: "Manualmente",
		FindResources: "Recursos em um raio máximo definido",
		SetRadiusOnMapTitle: "Defina o raio no mapa.",
		SetRadiusOnMapText: "Agora você pode desenhar o raio de busca de recursos no mapa.",
		AvailableResources: "Recursos disponíveis para atribuição",
		NoAvailableResources: "Recursos descartados",
		NoAvailableResourcesText:
			"Nenhum recurso disponível foi encontrado para atribuição, clique no botão visualizar recursos descartados para obter mais informações",
		NoAvailableResourcesDateText:
			"Não foram encontrados recursos disponíveis para a tarefa, a visita pertence a dias posteriores à data atual, para continuar reatribuí a visita para uma data igual ou superior à atual",
		AlertVisualizarInfo:
			"Para ver y gestionar una cita, haga clic sobre un elemento de la lista presentada a la esquerda.",
		Distance: "Distância",
		Notify: "Noticar",
		ResourcesWereNotified: "Todos os recursos foram notificados",
		ResourcesAssigned: "A visita foi atribuída ao recurso com sucesso",
		DateAssignedEnded: "O prazo para atribuir esta visita já terminou",
		ConfirmAssign: "Tem certeza de que deseja continuar atribuindo visitas ao recurso?",
		NoFoundEvents: "Nenhum evento encontrado para atribuir",
		AutomaticAllocation: "Alocação automática de recursos",
		AutomaticAllocationText:
			"Ativar a alocação automática de recursos impede que novos eventos estejam disponíveis para alocação neste painel",
		AutomaticAllocationTextAlert:
			"Se a atribuição automática de recursos for ativada, evitará que os novos eventos sejam exibidos neste painel",
		Enabled: "Ativado",
		Disabled: "Desativado",
		AvailableResourcesText:
			"Recursos com disponibilidade à data e hora da visita (Agenda, Atividades e Designação por ponto)",
		AvailableResourcesZone: "na mesma área que o ponto",
		AvailableResourcesZoneRelated: "Recursos atribuídos à mesma zona do ponto de visita",
		AvailableResourcesEvents: "Recursos com um número máximo de visitas atribuídas",
		AvailableResourcesLocation: "Encontre recursos levando em consideração as coordenadas de",
		AvailableResourcesLocationTracking: "Transmissão",
		AvailableResourcesLocationTrackingTitle: "Posição atual relatada pelos recursos em campo",
		AvailableResourcesLocationDefault: "Local padrão",
		AvailableResourcesLocationDefaultTitle:
			"Propriedade de recurso adicional para definir um ponto de localização padrão",
		SetFilters: "Definir critérios de pesquisa",
		NotifyOnCreateEnabledWarning:
			"Para ativar a alocação automática de recursos, é necessário que na configuração ON_DEMAND o valor de notify_on_create seja false",
		DisabledMapBtnTitle:
			"O rastreamento no mapa estará disponível assim que o recurso alterar o estado da visita a caminho",
		TrackingOnTheMap: "Rastreamento no mapa",
		ScheduledHour: "Hora programada",
		ExecutedHour: "Hora executada",
		DistanceToPoint: "Distância aérea até o ponto",
		ReachedThePoint: "Chegou ao ponto",
		RequestedVisits: "Visitas Solicitadas",
		AssignedVisits: "Visitas atribuídas",
		NotAssignedVisits: "Visitas não atribuídas",
		ViewResourceCalendar: "Exibir o calendário do recurso",
		AvailabilityFilters: "Filtros de disponibilidade",
		LocationFilters: "Filtros de localização",
		SearchResultAlert:
			"Clique nos marcadores correspondentes aos recursos para ver suas informações. Se pelo menos um dos filtros de localização estiver marcado, serão exibidas as zonas atribuídas ao recurso que cruzam com o ponto de visita",
		Free: "Livre",
		NotifyAllResources: "Notify all resources",
		NotDistance: "Fora do raio estabelecido",
		NotAvailability: "Não tem disponibilidade na agenda, atividade ou tarefa com o ponto de visita",
		NotLocation: "No default location",
		NotEvents: "Supera el máximo número de visitas asignadas",
		NotLocation1: "No active transmission",
		NotLocation2: "No default location",
		NotRelatedZone: "Não tem nenhuma zona relacionada onde o ponto de visita está localizado",
		NotLocationZone: "Não localizado na mesma zona que o ponto de visita",
		DiscardedBy: "Descartado por",
		SendNotify:
			"Notificar recursos, cria um leilão entre todos os recursos disponíveis para aceitar ou rejeitar a visita.  Você deseja continuar?",
		SelectDateRange: "Selecionar Intervalo de Datas",
		ChangeDate: "Alterar Data",
		ChangeDateText:
			"Permite definir um intervalo de datas para visualizar as visitas não gerenciadas dos dias subsequentes",
		HideVisitListOnSelect: "Ocultar lista de visitas ao selecionar uma",
		ShowList: "Mostrar lista",
		HideList: "Ocultar lista",
	},
	FormMessages: {
		RequiredName: "O nome é um campo obrigatório",
		RequiredLastname: "O sobrenome é um campo obrigatório",
		RequiredIdentification: "A identificação é um campo obrigatório",
		RequiredEmail: "E-mail é um campo obrigatório",
		InvalidEmail: "O email deve ter uma estrutura válida",
		RequiredUsername: "O nome de usuário é um campo obrigatório",
	},
	MassiveAssignment: {
		MassiveAssignment: "Atribuição Massiva",
		SelectedResources: "Recursos Selecionados",
		SelectedVisitPoints: "Pontos de Visita Selecionados",
		ShowAssignedVisitPointToltip: "Mostrar os pontos de visita atualmente atribuídos a este recurso.",
		SelectVisitPoints: "Selecionar pontos de visita",
		SelectResources: "Selecionar recursos",
		MaxSelectedResources: "Selecione no mínimo um recurso e no máximo quatro para continuar.",
		MaxSelectedResourcesReached: "Seleção máxima de recursos alcançada",
		MaxSelectedVisitPoints: "Selecione pelo menos um ponto de visita para continuar.",
		VisitPointsConfirmAssign: "Continuar atribuindo pontos de visita a recursos selecionados?",
		VisitPointsAssignationSuccessText: "A atribuição do ponto de visita foi bem-sucedida.",
		UploadFileNote:
			"Se você tiver um arquivo de atribuições em massa anteriores, poderá carregá-lo aqui, caso contrário, continue com a seleção de recursos",
		MassiveAssignmentUploadFile: "Selecionar arquivo de atribuição em massa",
		LoadMassiveAssignmentUploadFile: "Carregar arquivo para recuperar seleções anteriores",
		LoadMassiveAssignmentUploadFileError: "O arquivo não tem um formato válido para carregar as informações",
		ConfirmAssignText:
			"Marque Salvar, se desejar gerar um arquivo com as informações dos pontos de visita selecionados, que permitirá recuperar essa seleção em atribuições subsequentes.",
	},
	general: {
		AllFieldsRequired: "Todos os campos são obrigatórios para continuar",
		MapAppearance: "Aspecto do Mapa",
		MapTypes: "Tipos de Mapas",
		MapStyle: "Estilo de Mapa",
		WelcomeToRutify: "Bem Vindo a Rutify",
		LoginDescription: "Faça login e comece a curtir sua plataforma.",
		Email: "Correio Eletrônico",
		Emails: "E-mails",
		Remember: "Lembre de mim",
		RememberPassword: "¿Você não se lembra da sua senha?",
		ForgotPassword: "Redefina sua senha aqui",
		Styles: "Estilos",
		VisitPoints: "Pontos de Visita",
		VisitingPointsDescription: "Selecione os pontos de visita que deseja localizar no mapa.",
		Status: "Estado",
		GpsStatus: "Status do GPS",
		Navigation: "Navegação",
		ClearMap: "Limpar mapa",
		SubTitleZonification: "Criar e gerenciar zonas no mapa",
		Selectt: "Selecionar",
		DescriptionResource: "Selecione os recursos para atribuir no novo ponto de visita",
		SubTitleObject: "Conheça e gerencie o status de seus pedidos",
		SubTitleProperty:
			"Selecione um esquema para ver as propriedades mínimas que o objeto pode ter ou também para poder adicionar novas propriedades deste",
		SubTitleResource: "Crie e gerencie novos recursos e suas distribuições",
		SubTitleResourceUpdate: "Atualizar recursos e suas distribuições",
		Image: "Imagem",
		SubtitleVisitPoint: "Selecione os pontos de visita no novo recurso",
		SubtitleGroups: "Selecione os grupos para atribuir",
		SubtitleGroupsActivity: "Selecione os grupos para atribuir na nova atividade",
		SubtitleGroupsIndicator: "Selecione os grupos a serem atribuídos no novo indicador",
		SubtitleResource: "Visualize e gerencie novos recursos e suas distribuições",
		SubtitleReassing: "Selecione o novo recurso para reatribuir as visitas selecionadas",
		SubtitleVisitPoint2: "Visualize e gerencie os pontos de visita disponíveis",
		SubtitleVisitPointUpdate: "Atualizar e gerenciar pontos de visita",
		SubtitleDetailedInformation: "Informações detalhadas de um",
		SubtitleGroupsList: "Visualize e gerencie os grupos e recursos disponíveis em cada um",
		SubtitleGroupsCreate: "Selecione os recursos para atribuir no novo ponto de visita",
		SubtitleGroupsUpdate: "Atualize os recursos atribuídos no ponto de visita",
		SubtitleAssignedVisits: "Visualize e gerencie o rastreamento de visitas atribuídas",
		SubtitleOnDemand: "Crie e gerencie visitas não atribuídas no mapa",
		User: "Usuário",
		Scheduled: "Agendado",
		NotAssigned: "Não atribuído",
		Rescheduled: "Reprogramado",
		OnTheWay: "No meu caminho",
		InProgress: "Em progresso",
		Finalized: "Finalizado",
		Clear: "Limpar",
		Account: "Conta",
		LocationInformation: "Informação de localização",
		Visualize: "Visualizar",
		Return: "Retornar",
		New2: "Novo",
		Activities: "Atividades",
		Relevant: "relevante",
		Batteries: "Baterias",
		Load: "Carga",
		Archive: "Arquivo",
		ForgetYourPassword: "¿Você esqueceu sua senha?",
		BacktoStart: "Voltar ao início",
		NoDataFound: "Nenhum dado encontrado",
		RemoveSelection: "Remover Seleção",
		FormActivation: "Ativação de Formulário",
		SelectYourFile: "Selecione seu arquivo",
		Hour: "Tempo",
		Initial: "Inicial",
		End: "Final",
		Of: "de",
		SubtitleActivity: "Visualize e gerenciar as atividades disponíveis",
		SubtitleActivityCreate: "Insira os dados pertinentes para a nova atividade",
		SubtitleActivityUpdate: "Atualizar atividades e suas distribuições",
		SubtitleAlarmSchedule: "Ver e adicionar",
		SubtitleAlarmSchedule1: "alarmes de",
		SubtitleAlarmSchedule2: "relevantes",
		SubtitleAlarmCreate: "Insira os dados pertinentes para o novo alarme",
		SubtitleAlarmUpdate: "Atualiza os dados relevantes atribuídos a este alarme",
		SubtitleUploadFile: "Visualize e gerenciar arquivos de objetos",
		SubtitleUploadFileCreate: "Insira os dados pertinentes para o novo upload de arquivo",
		SubtitleReports: "Gerar e baixar relatórios de acordo com o indicador selecionado",
		SubtitleIndicators: "Selecione e visualize os indicadores que deseja analisar",
		SubtitleIndicatorsCreate: "Insira os dados pertinentes para o novo indicador",
		SubtitleIndicatorsUpdate: "Atualiza os dados relevantes atribuídos a este indicador",
		SubtitleCommunication: "Mantenha uma comunicação constante com seus recursos",
		SubtitleStatusMobile: "Visualize e gerenciar status de celular",
		SubtitleStatusMobileCreate: "Insira os dados pertinentes para o novo estado",
		SubtitleStatusMobileUpdate: "Atualiza os dados relevantes atribuídos a este estado",
		SubtitleRadiusCreate: "Insira os dados pertinentes para o novo alarme",
		SubtitleRadiusUpdate: "Atualiza os dados relevantes atribuídos a este alarme",
		SubtitleRol: "Visualize e gerenciar as funções geradas pelo recurso",
		SubtitleForgetPassword:
			"Insira o seu endereço de email. Enviaremos as instruções a seguir para redefinir sua senha.",
		SubtitleCompany: "Visualize e gerenciar as empresas disponíveis",
		SubtitleTypology: "Visualize e gerencie a tipologia disponível",
		SubtitleConfigCompany: "Visualize e gerencie todas as configurações disponíveis da empresa",
		SubtitleStatus: "Visualize e gerencie todos os estados disponíveis",
		SubtitlePermissions: "Visualize e gerencie todas as permissões disponíveis",
		SubtitleTypeConfig: "Visualize e gerencie cada tipo de configuração disponível",
		SelectAllResources: "Selecione todos os recursos",
		SelectAllVisitPoints: "Selecione todos os pontos de visita",
		RelationShipDescription:
			"Relación de los recursos contra los puntos de visita : all(relacion todos contra todos, un recurso puede atender cualquier punto de visita ), multi(relacion uno a varios, un punto de visita puede ser atendido por varios recursos ) y mono(relacion uno a um )",
		Raster: "Trama",
		RasterInformation: "Informações do quadro",
		Geofence: "cerca geográfica",
		SelectedZonesOnTheMap: "Selecione até seis zonas para visualizar no mapa",
		NoZonesAssigned: "Não há zonas atribuídas a este recurso",
		MaximumResourceReport: "Selecione no máximo três recursos",
		ZonesAllowedOnTheMap: "O número de zonas permitidas para exibição no mapa é seis",
		NoResultsFoundFor: "Nenhum resultado encontrado para",
		SearchResourceBy: "Recurso de pesquisa por",
		TheRole: "A Função",
		ValidateRoleResource:
			"não permite a relação de pontos de visita, grupos ou atividades, para fazê-lo você deve selecionar o papel EXECUTIVO ou SUPERVISOR",
		ValidateAssignVisitPointResource: "Você precisa definir o papel do recurso nas informações necessárias",
		NoModule: "A empresa não possui o módulo ou não está ativo",
		Images: "Imagens",
		Files: "Arquivos",
		EmailAlreadyAdded: "Este e-mail já foi adicionado",
	},
	CreatePasswordVP: {
		SecurityValidation: "Validação de Segurança",
		Question: "Pergunta",
		ToValid: "Para validar",
		QuestionsText: "Com qual das seguintes opções o usuário tem relacionamento no sistema?",
		RequiredAnswer: "Por favor, selecione uma opção para continuar",
		NoFoundCode: "Código não encontrado",
		NoFoundCodeText: "Por favor, verifique ou tente gerar outro código",
		PasswordRestored: "Senha Restaurada",
		PasswordRestoredText: "A senha foi redefinida ou criada com sucesso",
		ValidationCode: "Código de validação",
		WriteCode: "Escreva o código recebido por mensagem de texto",
		EnableOnDemandUser: "Ativar Usuário On-Demand",
		SentCode: "Um código de verificação foi enviado para o número de telefone",
		GoTo: "Ir para",
		CodeExpired: "O código expirou",
		CodeBlocked: "Código bloqueado",
		CodeExpiredText: "O código expirou, solicite um novo código com o administrador",
		CodeMaximumAttempts:
			"O código ultrapassou o número máximo de 3 validações, solicite um novo código com o administrador",
		BadAnswersText:
			"Uma ou mais das respostas de validação selecionadas não correspondem aos dados do ponto de visita, solicite um novo código ao administrador para tentar novamente",
		OnDemandUser: "Usuário On Demand",
		EnableOnDemandUserText:
			"Para habilitar um usuário On Demand a um ponto de visita, é necessário enviar um código de verificação para o celular que você deseja vincular ao registro",
		CellphoneAlreadyRegister: "O número do celular já está registrado em esta empresa",
		VisitPointAlreadyRegister: "O ponto de visita já possui um usuário cadastrado nesta empresa",
		CellphoneNoValid: "O número de celular enviado não é um número válido",
	},
	Preferences: {
		Preferences: "Preferências",
		FilterSearchTitle: "Tipo de pesquisas",
		FilterSearchNote: "Só funciona ao pesquisar através de campos adicionais",
		FilterSearchText:
			"Permite determinar se a pesquisa de pontos de visita ou recursos é estritamente igual aos critérios especificados ou se a pesquisa leva em consideração coincidências",
		FindExactly: "Pesquisar por critérios exatos",
		FindCoincidence: "Encontrar por partida",
		NumberDays: "Número de dias",
		NotificationNumberDays:
			"Configure o número de dias anteriores a partir dos quais a plataforma carregará e exibirá notificações",
		NotificationNumber:
			"Defina o número máximo de notificações que podem ser exibidas desde a última notificação recebida",
		DeleteOldNotification:
			"Ao iniciar a plataforma, exclua automaticamente as notificações anteriores aos dias anteriores estabelecidas anteriormente",
	},
	Chat: {
		Chat: "Bate-papo",
		Members: "Membros",
		LeaveGroup: "Sair do grupo",
		LeaveGroupText: "Tem certeza de que sair do grupo?",
		ClearHistory: "Excluir histórico",
		DeleteMemberText: "Tem certeza de que deseja excluir o membro?",
		DeleteChatText: "Tem certeza de que deseja excluir bate-papo?",
		ViewGroupInfo: "Ver informações do grupo",
		GroupAdded: "Bem vindo ao grupo",
		TypeYourMessage: "Digite sua mensagem",
		SearchOrStartANewChat: "Pesquise ou inicie um novo chat",
		SearchContact: "procurar contato",
		Contacts: "Contatos",
		StartConversation: "Iniciar Conversa",
		Online: "em linha",
		NoContactFound: "Nenhum contato encontrado",
	},
	Modules: {
		Modules: "Módulos",
		ACTIVITY: "ATIVIDADES",
		ALARMS: "ALARMES",
		CALENDAR: "CALENDÁRIO",
		CHAT: "BATER PAPO",
		COMMUNICATION: "COMUNICAÇÃO",
		COMPANY: "EMPRESA",
		COMPANYCONFIG: "COMPANY CONFIG",
		GROUPS: "GRUPOS",
		INDICATORS: "INDICADORES",
		MAP: "MAPA",
		MASSIVE_ASSIGNMENT: "ATRIBUIÇÃO EM MASSA",
		OBJECTS: "OBJETOS",
		ON_DEMAND: "UMA DEMANDA",
		PERMISSION: "PERMISSÃO",
		REPORTS: "RELATÓRIOS",
		RESOURCES: "RECURSOS",
		ROLE: "PAPEL",
		SERVIFORMS: "SERVIFORMS",
		SERVIROUTES: "SERVIROUTES",
		STATUS: "STATUS",
		STATUSMOBILE: "STATUS MÓVEL",
		STATUSMOBILEMANAGEMENT: "GERENCIAMENTO MÓVEL DE STATUS",
		TYPE_CONFIG: "TIPO DE CONFIGURAÇÃO",
		TYPOLOGY: "TIPOLOGIA",
		UPLOAD_FILES: "UPLOAD FILES",
		VISIT_POINT: "PONTO DE VISITA",
		ZONIFICATION: "ZONIFICAÇÃO",
		SESSION_API: "SESION API",
	},
	SessionApi: {
		SessionApi: "Sessão por API",
		AccessToken: "Token de acceso",
		ExpireDate: "Fecha de expiración",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copiar",
		Copied: "Copied",
		CopiedText: "Token copied to clipboard successfully",
	},
	DesignConfig: {
		MinimumCharacterLength: "Comprimento mínimo de caracteres",
		MaximumCharacterLength: "Comprimento máximo de caracteres",
		MinimumVal: "Valor mínimo",
		MaximumVal: "Valor máximo",
		Option: "Opção",
		SwitchText: "Alternar Activo / Inactivo",
		SelectMinimumOneOption: "Selecione no mínimo uma opção",
		LoadOptions: "Carregar lista de opções",
		CalendarStatus: "Status do calendário",
		Composed: "Composta",
		AllowValues: "Esta propriedade pode receber um dos seguintes valores",
	},
	CompanyModule: {
		MissingServiceTime: "Tempo de serviço ausente",
		Month: "Mês",
		Year: "Ano",
		Day: "dia",
		Month: "Mêses",
		Year: "Anos",
		Day: "Dias",
		AllDescription: "Os pontos de visita da plataforma podem ser atendidos por qualquer recurso ",
		MonoDescription: "O ponto de visita só pode ser servido por um recurso",
		MultiDescription: "O ponto de visita pode ser servido por vários recursos",
		AdminResourceDescription:
			"El recurso administrador é o primeiro recurso da empresa el cual é necessário para agregar configurações como SERVIROUTES",
		AccessToken: "Token de acesso",
		GenerateAccessToken: "Gerar token de acesso por API",
	},
	EventTracking: {
		EventTracking: "Rastreamento de Eventos",
		EventStatusBtn: "Verificar",
		Tracking: "Rastreamento",
		TrackingText:
			"Por favor, insira o código único fornecido para rastrear o progresso, status e detalhes do evento.",
		TrackingCode: "Código de Rastreamento Exemplo: 10000a19t45b1738b77877",
		TrackingCodeRequired: "O código de rastreamento é obrigatório",
		TrackingCodeInvalid: "O código de rastreamento é inválido",
		EventDetails: "Detalhes do Evento",
		EventDetailsText:
			"Informações essenciais sobre o status do evento serão exibidas, garantindo a confidencialidade dos dados sensíveis.",
		TrackingHistory: "Histórico de Mudanças de Status",
		NextStops: "Próximas Paradas",
		Location: "Localização",
		EstimatedTimeArrival: "Hora Estimada de Chegada",
		EstimatedTimeArrivalNextStop: "Hora Estimada de Chegada na próxima parada",
		EventNotFound: "Evento não encontrado",
		Message: "Mensagem",
		EventNotFoundText:
			"O evento que você está procurando não está em nossos registros. Verifique o código inserido e tente novamente.",
		EventScheduleInformation: "Informações de Programação do Evento",
		ScheduleDate: "Data de Programação",
		ScheduleInitHour: "Hora de Início Programada",
		ScheduleEndHour: "Hora de Término Programada",
		Print: "Imprimir",
		Updates: "Atualizações",
		AlphaNumeric: "Apenas caracteres alfanuméricos são permitidos e no máximo 22 caracteres",
	},
	Waypoint: {
		Waypoint: "Ponto de Passagem",
		Waypoints: "Pontos de Passagem",
		WaypointText:
			"Um ponto de passagem é um ponto de interesse que deve ser visitado antes de chegar ao ponto de visita, para realizar uma tarefa de entrega ou coleta",
		WaypointList: "Lista de Pontos de Passagem",
		SelectWaypoint: "Selecionar Ponto de Passagem",
		SelectWaypointText: "Selecione um ponto de passagem para ver suas informações",
		NoWaypointFound: "Nenhum ponto de passagem encontrado",
		NoWaypointFoundText: "Nenhum ponto de passagem encontrado na visita selecionada",
		WaypointDetails: "Detalhes do Ponto de Passagem",
		WaypointsConfiguration: "Configuração de Pontos de Passagem",
		WaypointConfiguration: "Configuração de Ponto de Passagem",
		WaypointConfigurationText:
			"Configuração dos pontos de passagem que devem ser atendidos pelo recurso antes de chegar ao ponto de visita",
		Delivery: "Entrega",
		Pickup: "Coleta",
		order: "Ordem",
		cx: "Latitude",
		cy: "Longitude",
		job_type: "Tipo de trabalho",
		priority: "Prioridade",
		service_time: "Tempo de serviço",
		capacity: "Capacidade",
		OrderText: "Ordem em que o ponto de passagem deve ser atendido",
		JobTypeText: "Tipo de trabalho a ser realizado no ponto de passagem",
		PriorityText:
			"Prioridade de atendimento do ponto de passagem varia de 0 a 10, onde 10 é a prioridade mais alta",
		WaypointInformation: "Informações do Ponto de Passagem",
		EnterWaypointInformation: "Insira as informações do ponto de passagem para continuar",
		NotWaypointAdded: "Nenhum ponto de passagem adicionado",
		AddWaypoints: "Adicionar Pontos de Passagem",
		AddWaypointText:
			"Para adicionar um ponto de passagem, clique no local desejado no mapa e complete as informações solicitadas ou use o botão adicionar para geo-referenciar um endereço",
		ReorderWaypoints: "Reordenar Pontos de Passagem",
		ReorderWaypointsText:
			"Para reordenar os pontos de passagem, arraste e solte os pontos de passagem na ordem desejada na lista",
		OpenWaypointConfiguration: "Abrir configuração de ponto de passagem",
		CloseWaypointConfiguration: "Fechar configuração de ponto de passagem",
		OpenWaypointConfigurationView:
			"Clique para abrir ou fechar a visualização de configuração de pontos de passagem",
		WaypointConfigurationNotAvailable:
			"A configuração de ponto de passagem está disponível apenas para a criação de uma visita por vez",
		WaypointConfigurationNotAvailableText:
			"Para configurar pontos de passagem, você deve primeiro adicionar uma visita à lista de visitas para atribuir ao recurso",
		WaypointsReordered: "Pontos de passagem reordenados com sucesso",
		ServiroutesErrorCreate: "Ocorreu um erro ao processar os pontos de passagem no Serviroutes",
		WaypointsRouteFetched: "Rota para os pontos de parada obtida com sucesso",
		RoutingFetchError: "Erro ao obter a rota para os pontos de parada",
		MaxWaypointsReached: "Número máximo de pontos de passagem alcançado",
	},
	Follower: {
		Follower: "Seguidor",
		Followers: "Seguidores",
		FollowersText:
			"Os seguidores são usuários que são notificados sobre mudanças no status de uma visita ou evento de um recurso.",
		FollowersList: "Lista de Seguidores",
		SelectFollower: "Selecionar Seguidor",
		SelectFollowerText: "Selecione um seguidor para ver suas informações",
		NoFollowerFound: "Nenhum seguidor encontrado",
		NoFollowerFoundText: "Nenhum seguidor foi encontrado para a visita selecionada",
		FollowerDetails: "Detalhes do Seguidor",
		FollowersConfiguration: "Configuração de Seguidores",
		FollowerConfiguration: "Configuração de Seguidor",
		FollowerConfigurationText:
			"Configuração dos seguidores que receberão notificações sobre as visitas de um recurso",
		FollowBy: "Seguido por",
		FollowersInformation: "Informações do Seguidor",
		EnterFollowerInformation: "Insira as informações do seguidor para continuar",
		NotFollowerAdded: "Nenhum seguidor foi adicionado",
		AddFollowers: "Adicionar Seguidor",
		AddFollowerText:
			"Para adicionar um seguidor, insira um número de telefone ou endereço de e-mail e clique no botão adicionar",
		SelectEvent: "Selecionar Evento",
		SelectEventText:
			"Escolha a visita à qual deseja adicionar seguidores. Se acessado pelo calendário, a visita será selecionada automaticamente.",
		SearchEvent: "🔍 Buscar evento...",
		SearchEventText: "Busque um evento pelo nome do recurso ou identificador do evento",
		SearchEventNotFound: "Nenhum evento encontrado",
		SelectNotificationChanel: "Canais e Tipos de Notificação",
		SelectNotificationChanelText:
			"Escolha por qual canal deseja receber notificações sobre os eventos do recurso. Você pode selecionar um ou mais canais.",
		SelectNotificationChanelText2:
			"Escolha o status do evento para o qual deseja receber notificações. Você pode selecionar um ou mais status.",
		Email: "E-mail",
		Sms: "Mensagem de Texto (SMS)",
		WhatsApp: "WhatsApp",
		RecipientSettings: "Configurações de Destinatários",
		RecipientSettingsEmail: "Configurações de E-mail",
		RecipientSettingsSmsOrWhatsApp: "Configurações de SMS ou WhatsApp",
		RecipientSettingsText: "Insira as informações dos destinatários para cada canal de notificação selecionado",
		RecipientSettingsTextAlertText:
			"Por favor, selecione pelo menos um canal de notificação para continuar com a configuração",
		RecipientSettingsEmailText:
			"Insira os endereços de e-mail para os quais as notificações serão enviadas. Você pode adicionar vários endereços separados por vírgulas.",
		RecipientSettingsEmailPlaceholder: "Exemplo: exemplo@email.com, outro@email.com",
		RecipientSettingsEmailPlaceholderList: "Lista de e-mails adicionados (com opção de excluir)",
		RecipientSettingsEmailError: "Insira pelo menos um endereço de e-mail",
		RecipientSettingsEmailErrorInvalid: "Insira um endereço de e-mail válido",
		RecipientSettingsEmailErrorDuplicate: "O endereço de e-mail já foi adicionado",
		RecipientSettingsSmsOrWhatsAppText:
			"Insira os números de telefone para os quais as notificações serão enviadas via SMS ou WhatsApp. Lembre-se de incluir o código do país.",
		RecipientSettingsSmsOrWhatsAppPlaceholder: "+55 1234567890, +55 9876543210",
		RecipientSettingsSmsOrWhatsAppPlaceholderList: "Lista de números adicionados (com opção de excluir)",
		RecipientSettingsSmsOrWhatsAppError: "Insira pelo menos um número de telefone",
		RecipientSettingsSmsOrWhatsAppErrorInvalid: "Insira um número de telefone válido",
		RecipientSettingsSmsOrWhatsAppErrorDuplicate: "O número de telefone já foi adicionado",
		Template: "Modelo",
		Templates: "Modelos",
		TemplateSettings: "Configurações de Modelos",
		TemplateSettingsText:
			"O modelo define a estrutura e o conteúdo das mensagens de notificação que serão enviadas aos seguidores do evento",
		SelectTemplate: "Selecionar Modelo",
		SelectTemplateText: "Escolha o modelo que será usado para enviar notificações aos seguidores",
		TemplateText: "Texto do Modelo",
		PleaseSelectTemplate: "Por favor, selecione um modelo para ver sua estrutura e conteúdo aqui",
		SelectTemplateError: "Selecione um modelo para continuar",
		email: "E-mail",
		cell_phone: "Números de Telefone",
		in_event_status: "No Status do Evento",
		template_name: "Nome do Modelo",
		whatsapp: "WhatsApp",
		sms: "SMS",
		to_email: "E-mails",
		event_id: "Identificador do Evento",
		email_error: "Pelo menos um e-mail é necessário se o canal de notificação por e-mail estiver selecionado",
		cell_phone_error:
			"Pelo menos um número de telefone é necessário se o canal de notificação por SMS ou WhatsApp estiver selecionado",
		in_event_status_error: "Pelo menos um status de evento é necessário",
		template_name_error: "O nome do modelo é obrigatório",
		event_id_error: "Por favor, selecione uma visita para continuar",
		NoEmailsYet: "Nenhum e-mail foi adicionado",
		NoCellPhonesYet: "Nenhum número de telefone foi adicionado",
		NoEventStatusYet: "Nenhum status de evento foi selecionado",
		SelectLanguage: "Selecionar Idioma",
		SelectVisit: "Selecionar Visita",
		SearchVisit: "Buscar Visita",
		SearchVisitByDate: "Buscar Visita por Data",
		SetDateRange: "Definir Intervalo de Datas",
		SearchVisitByDateText:
			"Busque uma visita pela data de início ou defina um intervalo de datas para mais resultados",
		SelectVisitText: "Escolha a visita à qual deseja adicionar seguidores",
		SearchVisitText: "Busque uma visita pelo nome do recurso ou identificador da visita",
		SearchVisitNotFound: "Nenhuma visita encontrada",
		SelectLanguageText: "Escolha o idioma no qual deseja receber notificações",
		ConfigCompanyRequired: "A empresa deve ter a configuração {id} para continuar com esta funcionalidade",
		PleaseContactAdmin:
			"Por favor, entre em contato com o administrador da plataforma para ativar esta configuração para a empresa",
		alreadyExistToPhoneNumber:
			"A visita já tem uma notificação atribuída para o status {id} via SMS ou WhatsApp com o número de telefone ",
		alreadyExistToEmail:
			"A visita já tem uma notificação atribuída para o status {id} via e-mail para o endereço de e-mail ",
	},
};
